import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCCustomDomain(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 506.906 500.383">
            <g id="Custom_Domain" transform="translate(-4.525 0.933)">
                <ellipse
                    id="_Path_"
                    data-name="&lt;Path&gt;"
                    cx="101.88"
                    cy="15.98"
                    rx="101.88"
                    ry="15.98"
                    transform="translate(165.02 467.49)"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_1"
                    data-name="Ellipse 1"
                    cx="29.08"
                    cy="29.08"
                    r="29.08"
                    transform="translate(8.304 190.313) rotate(-22.08)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M29.47,210.33a2.41,2.41,0,1,1,1.155,2.216A2.41,2.41,0,0,1,29.47,210.33Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M49.71,207H39.63c.37,1.66,1.79,2.67,3.82,2.67a4.54,4.54,0,0,0,3.34-1.28l2.06,2.23a7,7,0,0,1-5.5,2.15c-4.61,0-7.61-2.9-7.61-6.86A6.78,6.78,0,0,1,42.85,199a6.59,6.59,0,0,1,6.94,7C49.79,206.24,49.74,206.67,49.71,207Zm-10.13-2.26h6.57a3.33,3.33,0,0,0-6.57,0Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M51.08,211.32l1.29-2.77A9.11,9.11,0,0,0,57,209.84c1.79,0,2.45-.47,2.45-1.22,0-2.18-8.05,0-8.05-5.27,0-2.53,2.28-4.31,6.17-4.31a11,11,0,0,1,5.13,1.16L61.41,203a7.66,7.66,0,0,0-3.84-1c-1.73,0-2.48.54-2.48,1.24,0,2.28,8.06.07,8.06,5.32,0,2.48-2.31,4.24-6.3,4.24a11.42,11.42,0,0,1-5.77-1.48Z"
                    fill="#e4e3e3"
                />
                <circle
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="40.7"
                    cy="40.7"
                    r="40.7"
                    transform="translate(38.07 283.7)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M55.39,330a3.37,3.37,0,1,1,1.627,3.071A3.37,3.37,0,0,1,55.39,330Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M77.37,314.18v5c-.45,0-.79-.07-1.21-.07-3,0-5,1.63-5,5.2v8.81H65.79V314.45H71v2.47C72.28,315.11,74.49,314.18,77.37,314.18Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M99.53,314.45v18.66H94.4v-2.22a7.54,7.54,0,0,1-5.79,2.5c-4.68,0-8-2.64-8-8.39V314.45H86v9.75c0,3.12,1.39,4.51,3.78,4.51s4.3-1.6,4.3-5v-9.23Z"
                    fill="#e4e3e3"
                />
                <circle
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="32.77"
                    cy="32.77"
                    r="32.77"
                    transform="translate(403.59 322.33)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M417.54,359.61a2.71,2.71,0,1,1,1.3,2.484,2.71,2.71,0,0,1-1.3-2.484Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M439.48,353.55v8.57h-4.07v-1.87c-.81,1.37-2.38,2.09-4.58,2.09-3.52,0-5.61-1.95-5.61-4.55s1.87-4.49,6.45-4.49h3.46c0-1.87-1.12-3-3.46-3a7.25,7.25,0,0,0-4.33,1.39l-1.56-3a11.53,11.53,0,0,1,6.47-1.81C436.83,346.88,439.48,349,439.48,353.55Zm-4.35,3.82v-1.53h-3c-2,0-2.68.75-2.68,1.76s.92,1.81,2.46,1.81a3.21,3.21,0,0,0,3.22-2.04Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M458.55,347.1v15h-4.13v-1.79a6.09,6.09,0,0,1-4.66,2c-3.77,0-6.42-2.12-6.42-6.75V347.1h4.35v7.84c0,2.52,1.12,3.63,3,3.63s3.47-1.28,3.47-4V347.1Z"
                    fill="#e4e3e3"
                />
                <circle
                    id="Ellipse_4"
                    data-name="Ellipse 4"
                    cx="26.13"
                    cy="26.13"
                    r="26.13"
                    transform="translate(437.92 225.27)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M449.05,255a2.16,2.16,0,1,1,2.16,2.16A2.16,2.16,0,0,1,449.05,255Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M455.3,241.41a2.167,2.167,0,0,1,4.32-.07,2.17,2.17,0,0,1-4.32.07Zm.42,3.6h3.48v12h-3.48Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M474.67,250.14V257H471.2v-6.33c0-1.94-.89-2.83-2.43-2.83s-2.87,1-2.87,3.23V257h-3.47V245h3.31v1.41a5.24,5.24,0,0,1,4-1.58C472.54,244.84,474.67,246.48,474.67,250.14Z"
                    fill="#e4e3e3"
                />
                <circle
                    id="Ellipse_5"
                    data-name="Ellipse 5"
                    cx="33.28"
                    cy="33.28"
                    r="33.28"
                    transform="translate(32.02 21.69)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M46.18,59.55a2.75,2.75,0,1,1,2.75,2.75,2.75,2.75,0,0,1-2.75-2.75Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_14"
                    data-name="Path 14"
                    d="M70.22,46.84V59.55c0,5.67-3.06,8.28-8.56,8.28a12.54,12.54,0,0,1-7.48-2.1l1.75-3.18a9.15,9.15,0,0,0,5.39,1.73c3.12,0,4.48-1.42,4.48-4.17v-.65a6.25,6.25,0,0,1-4.8,1.9c-4.22,0-7.63-2.92-7.63-7.37s3.41-7.37,7.63-7.37a6.13,6.13,0,0,1,5,2.18v-2ZM65.86,54a4,4,0,1,0-4,3.74,3.7,3.7,0,0,0,4-3.74Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M74.34,41.06h4.42v21H74.34Z"
                    fill="#e4e3e3"
                />
                <circle
                    id="Ellipse_6"
                    data-name="Ellipse 6"
                    cx="40.31"
                    cy="40.31"
                    r="40.31"
                    transform="translate(405.675 30.645) rotate(-23.06)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_16"
                    data-name="Path 16"
                    d="M433.14,58.09a3.07,3.07,0,1,1,1.48,2.8,3.07,3.07,0,0,1-1.48-2.8Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_17"
                    data-name="Path 17"
                    d="M459.53,43.93v17h-4.68v-2a6.9,6.9,0,0,1-5.28,2.27c-4.27,0-7.27-2.4-7.27-7.65V43.93h4.93v8.89c0,2.84,1.27,4.1,3.45,4.1s3.92-1.45,3.92-4.58V43.93Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_18"
                    data-name="Path 18"
                    d="M471.41,54.27,469,56.61v4.33h-4.93V37.49H469V50.76l7.21-6.83h5.87L475,51.14l7.72,9.8h-6Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_19"
                    data-name="Path 19"
                    d="M427.37,171.62c-.18-1.92-.4-3.81-.66-5.71s-.56-4-.89-6q.49,3,.89,6C427,167.81,427.19,169.7,427.37,171.62Z"
                    fill="#263238"
                />
                <path
                    id="Path_20"
                    data-name="Path 20"
                    d="M412.06,195.29c-1.66-3.73-2-7.87-3.13-11.79-.58-2.11-1.57-4.35-3.54-5.29-1.31-.61-2.86-.53-4.25-1-5-1.49-6.35-8.46-11.07-10.62a16.419,16.419,0,0,0-4.75-1c-6.33-.74-12.86-2.93-16.84-7.89-1.31-1.6-2.29-3.5-3.9-4.81s-4.13-1.86-5.71-.53c1.34,2.67,2.65,5.34,3.95,8,1.2,2.4,2.43,4.88,4.43,6.64s5,2.72,7.45,1.6a5,5,0,0,1,2.51-.88,2.7,2.7,0,0,1,1.62,1c3.45,3.82,2.33,10.14-1,14s-8.3,5.9-13.07,7.79c-1.71.67-3.52,1.36-5.34,1-3.31-.61-5.07-4.21-6-7.44-2.16-7.15-3.2-14.92-7.63-20.95-1.42-1.89-3.18-3.63-4-5.84-.91-2.41-.7-5.21-2.14-7.32s-4.67-3.49-4.88-6.16c-.13-1.87,1.42-3.52,3.12-4.32s3.63-1.07,5.39-1.79c.7-.29,1.47-.8,1.5-1.55,0-1.12-1.55-1.57-1.95-2.61s.77-2.27,1.28-3.42c1.09-2.61-1.63-5.26-4.27-6.32s-5.79-1.84-7-4.41a15.171,15.171,0,0,1-.85-3.81c-.61-3.23-3-6.35-6.25-6.89s-6.91,2.38-6.37,5.63c.32,1.79,1.65,3.18,2.37,4.83s.54,4.11-1.17,4.65c-2.8.85-5.5-4.27-7.85-2.51,1,3.28,1.9,6.56,2.86,9.87-3.68,1.87-8.09-1.52-9.66-5.36s-1.63-8.19-3.5-11.88-6.91-6.45-10.11-3.84c-.16,4.75,6.11,6.67,8.88,10.51,2,2.78,1.71,7.29-1.25,9s-7.6-1.31-6.48-4.54c.4-1.12,1.33-2,1.44-3.25.1-1.5-1.15-2.7-2.3-3.66-1.79-1.52-3.57-3-5.36-4.51a11.36,11.36,0,0,0-3.82-2.4c-3.68-1.07-7.36,1.92-9.31,5.21s-3,7.17-5.74,9.92c-3.87,4-11.2,4.24-14.83.06s-1.79-12,3.57-13.56c2-.56,4.59-.51,5.66-2.3,1.87-3.17-3.47-7.23-1.63-10.43,1.42-2.45,5.15-1.33,7.87-2.16s4.22-3.55,5.82-5.9,4.06-4.67,6.83-4.05c-.21-1.63-.43-3.39.3-4.86s2.74-2.46,4.08-1.49c-1.36,2.24.26,5.36,2.64,6.48s5.15.85,7.76.56,5.9-1.28,6.12-3.9c.08-.85-.24-1.76.08-2.56,1.14-3.12,6.91,1.18,9.12-1.33,1.28-1.31-.13-3.63-1.92-4.06s-3.6.22-5.42.27-4-.88-4.11-2.7,1.93-3.07,2.14-4.83c.35-3-4.72-3.76-6.51-1.33s-1.15,5.76-.62,8.73.83,6.45-1.36,8.53c-.93,1.42-3.36.67-4.16-.82s-.64-3.31-.77-5-.88-3.63-2.54-4.09c-1.15-.32-2.37.24-3.55.4-4.64.56-7.87-5.44-6.4-9.87s5.65-7.31,9.74-9.58c3-1.65,6.7-3.2,9.66-1.52,1.39.77,2.35,2.11,3.71,2.91,2.35,1.39,5.25.88,8,.93a18.6,18.6,0,0,1,11.61,4.51c1.2,1.1,2.32,2.91,1.38,4.22s-3.92,1.68-3.41,3.31a5.79,5.79,0,0,0,7.26-4.67,4.86,4.86,0,0,1,2.8,4c3.39-3.45,9.9-2.94,12.67,1,.75,1,1.29,2.29,2.35,3s2.94.35,3.07-.9a2.68,2.68,0,0,0-.21-1.18c-.64-1.81-1.31-3.6-1.95-5.39,2.48-1.33,5.42.75,7.1,3,6.24,8.35,10.7,3.34,19.5,4.7,6,.9,8.57,4.72,11.93,9.34,10.3,14.19,23.91,25.83,33.28,40.66,1,1.55,1.89,3.13,2.75,4.73-.16-.4-.3-.8-.46-1.2a163.818,163.818,0,0,0-13.61-27.68c-1.14-1.86-2.32-3.7-3.52-5.52-.75-1.12-1.52-2.27-2.29-3.36-1-1.44-2-2.83-3.07-4.22-.83-1.12-1.66-2.21-2.51-3.28-.59-.75-1.2-1.49-1.81-2.24s-1.34-1.68-2.09-2.51L386,76.81a8.654,8.654,0,0,0-.72-.8c-.77-.91-1.6-1.79-2.43-2.67a.73.73,0,0,0-.24-.26c-.21-.24-.45-.48-.69-.72-.67-.75-1.39-1.47-2.08-2.19-1.15-1.18-2.32-2.35-3.52-3.47-1-1-2-1.92-3.05-2.86s-1.81-1.65-2.74-2.45-1.82-1.58-2.75-2.35q-1.68-1.44-3.45-2.83h0c-3.23-2.59-6.57-5-10-7.34-.86-.58-1.68-1.14-2.54-1.7s-1.73-1.13-2.59-1.66-1.73-1.09-2.61-1.6-1.76-1.07-2.64-1.58c-.72-.42-1.42-.82-2.14-1.2a11.92,11.92,0,0,0-1.09-.61c-1.52-.85-3.07-1.68-4.62-2.45-.77-.41-1.55-.81-2.35-1.18-1-.51-2-1-3-1.44a2.4,2.4,0,0,0-.46-.21c-.9-.43-1.81-.86-2.74-1.26-1.31-.56-2.62-1.12-3.93-1.65-1.49-.62-3-1.23-4.51-1.79-1.68-.64-3.36-1.25-5.07-1.81s-3.44-1.15-5.17-1.69-3.47-1-5.23-1.49q-5.2-1.39-10.54-2.48a1.8,1.8,0,0,0-.19-.05c-1.36-.27-2.72-.54-4.08-.75a1.11,1.11,0,0,0-.27-.06c-.59-.1-1.2-.21-1.82-.29-2.53-.43-5.09-.77-7.68-1.07a8.829,8.829,0,0,0-.93-.1c-.75-.11-1.5-.16-2.27-.24-1.71-.16-3.42-.3-5.15-.4s-3.6-.22-5.42-.27-3.79-.11-5.68-.11q-7.53,0-14.89.67c-1.18.08-2.32.19-3.47.32s-2.4.27-3.6.43-2.41.32-3.58.5-2.38.38-3.58.59c-1,.16-2.05.35-3.07.56-2.5.48-5,1-7.44,1.6-1.15.27-2.3.56-3.44.88s-2.3.62-3.42.94c-1.89.53-3.73,1.12-5.58,1.71h0c-1.5.5-3,1-4.48,1.52a.18.18,0,0,0-.11.05c-1.52.53-3,1.09-4.48,1.68l-.25.08c-1.36.53-2.72,1.09-4,1.66-1.68.69-3.34,1.44-5,2.18-1.39.64-2.75,1.28-4.09,1.95s-2.88,1.44-4.29,2.19l-.16.08c-1.36.72-2.73,1.47-4.06,2.24s-2.75,1.58-4.11,2.43h0c-1.28.77-2.53,1.55-3.78,2.35-.49.29-.94.61-1.42.93-1.33.86-2.61,1.74-3.92,2.64-1.6,1.1-3.15,2.24-4.7,3.39-1.36,1-2.69,2.06-4,3.1a167.931,167.931,0,0,0-21,19.88c-2.26,2.51-4.4,5.07-6.48,7.68-1.76,2.24-3.47,4.51-5.1,6.86-1.46,2-2.88,4.12-4.24,6.24,1.36-2.12,2.78-4.2,4.24-6.24.43,0,.86-.11,1.28-.13,2.41-.19,4.94-.11,7.1-1.15,2-1,3.42-2.78,5.23-4.06,4.65-3.3,12.25-3.92,13.51-9.47.42-1.87-.09-3.89.61-5.68,1.31-3.34,5.76-3.82,9.34-3.77,1.52,0,3.31.22,4,1.55a3.83,3.83,0,0,1-.16,3.1,29.05,29.05,0,0,1-12.25,15.05c-4.64,2.83-10.7,5-12,10.3.64,1.79,3.9,1.65,4.16,3.52.19,1.5-1.73,2.27-2.42,3.6-1,1.95,1.3,4.33,3.52,4.22s4.05-1.71,5.68-3.2c4.86-4.51,10-9.37,11.72-15.77.74-2.65,1-5.74,3.15-7.5,2.53-2.08,7.07-.64,7.92,2.53,2.11-1.17,5.39-2,6.49.14a11.6,11.6,0,0,1,.45,2.5c.69,3.42,5.36,5,5.84,8.41.56,4-4.53,6-8.51,6.65q-5.4.84-10.81,1.7a10,10,0,0,0-4.48,1.44c-1.28,1-2.08,2.78-1.33,4.19a10.23,10.23,0,0,0,1.86,1.92c3,3,.54,9.16-3.68,9.29-1.44,0-2.85-.48-4.3-.53-4.26-.19-7.65,3.57-9.68,7.34s-3.55,8-7,10.62c-5.49,4.13-15,3.17-17.64,9.52-1.06,2.56-.5,5.45-.08,8.19s.62,5.77-1,8-5.69,2.72-6.86.21a6.12,6.12,0,0,1-.16-3.55c.64-3.95,1.25-7.9,1.87-11.85.45-2.93.85-6.21-.88-8.62-2.43-3.36-7.88-3-11-.34s-4.43,6.91-5.31,10.94c-.64,3-1.39,7.2-3,10.62h0c-.56,3.31-1,6.67-1.36,10.06s-.58,6.91-.72,10.43A13,13,0,0,0,92.53,180c1.68-1.73,5.07-9.07,8.12-5.47a2.73,2.73,0,0,1,0,3.34c-.94,1.2-2.8,1.46-3.52,2.77-.88,1.55.34,3.47,1.78,4.49s3.21,1.68,4.22,3.14c1.95,2.81.08,7,2,9.9,1.62,2.46,5.09,2.62,8,2.94l1,.16c.83-5.87,3.57-10.65,11.58-12.46,11.05-2.51,25.56,6.64,31.78,15,6.94,9.31,10.22,22.49,20.84,27.16,7.61,3.34,18.41,2.14,22.12,9.58,3.31,6.67-2.45,14.17-3.33,21.56-.56,4.89,1,9.74,1.41,14.63s-1.09,10.62-5.55,12.67c-2.48,1.12-5.6,1-7.6,2.86-3.55,3.36-.64,10.3-4.19,13.66-1.26,1.17-3,1.6-4.51,2.38-8,4-7.77,15.77-4.06,23.91.13.29.27.56.4.85a168.681,168.681,0,0,0,165.61,4.19h0a170.722,170.722,0,0,0,48.68-39c2.83-3.26,5.49-6.65,8.06-10.12,1.3-1.79,2.58-3.57,3.78-5.42a160.516,160.516,0,0,0,10.06-16.83,162.366,162.366,0,0,0,10.92-26.31A164.383,164.383,0,0,0,426.68,211c.51-3.79.91-7.64,1.17-11.5a9.74,9.74,0,0,1-6.77,3C417,202.42,413.68,199,412.06,195.29Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M113,232.65c-.54-4.83,1.06-9.66,1.14-14.54.06-3.36-.18-6.91-.24-10.3a47.439,47.439,0,0,1-8.56-1.2,2.61,2.61,0,0,1-1.58-.8,3.12,3.12,0,0,1-.34-1.79c-.22-3.79-3.87-6.3-7.15-8.19a29,29,0,0,0-5.21-2.57v1.18a167.93,167.93,0,0,0,10.73,53.5,161.42,161.42,0,0,0,10.3,22.1c1.65,3.07,3.47,6.08,5.36,9,2.35,3.66,4.8,7.23,7.45,10.68,2.45,3.31,5.07,6.53,7.81,9.63a166.445,166.445,0,0,0,11.93,12.27q5.56,5.2,11.61,9.88c-9.21-24.71-17.88-49.93-33.62-71C118.55,245.09,113.8,239.48,113,232.65Z"
                    fill="#f3725f"
                />
                <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M91.07,185.29c0,1-.06,2-.06,3v0C91,187.31,91.05,186.3,91.07,185.29Z"
                    fill="#263238"
                />
                <g id="Group_1" data-name="Group 1" opacity="0.6">
                    <path
                        id="Path_23"
                        data-name="Path 23"
                        d="M165.75,328.37c1.41,1,2.85,1.89,4.3,2.8,1,.64,2,1.26,3.07,1.87-1-.61-2.05-1.23-3.07-1.87C168.6,330.26,167.16,329.33,165.75,328.37Z"
                        fill="#263238"
                    />
                </g>
                <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M308.56,317.79a14.309,14.309,0,0,1-3.14-.33,10.28,10.28,0,0,1-7.45-5.63,19.449,19.449,0,0,1-1.29-7.35,28,28,0,0,0-.53-5c-.68-2.91-2.28-5.41-4-8.06a36.85,36.85,0,0,1-3.43-6.22c-1.61-4.05-1.73-8.49-1.85-12.78v-1c-.89-29.66-9.16-53.73-23.91-69.62-2.05-2.21-4.35-4.35-7.24-5.12a9,9,0,0,0-9.28,3.2,19,19,0,0,0-1.41,2.29,12.76,12.76,0,0,1-2.44,3.47,7,7,0,0,1-5.93,1.61,10.74,10.74,0,0,1-7.4-5.11c-2.62-4.61-2.15-10.3-1.77-14.87l1.52-18.4c.24-2.84.56-6.73,2.86-9.39,1.78-2.06,4.35-3,6.84-3.93A20.241,20.241,0,0,0,244,153c2.95-2.21,4.26-5.71,5.65-9.4a39.349,39.349,0,0,1,2.68-6.09,11.36,11.36,0,0,1,10.57-5.2,5,5,0,0,1,3.87,2.59c1.83-3.43,4.08-5.49,6.87-6.29,6.1-1.75,13.53,3.08,20.72,7.74,6.56,4.26,12.75,8.28,17.62,7.4,1.22-.23,2.46-.58,3.67-.92,2.56-.72,5.21-1.47,7.91-1.08,7.09,1,10.7,8.67,13.06,15.26l11.53,32.2c1.43,4,3.28,8.41,7.09,9.89a14.57,14.57,0,0,0,4.82.7,16.46,16.46,0,0,1,5,.72,8.07,8.07,0,0,1,5.3,6.5c1,5.32-1.69,12.28-6.21,16.19h0a75.258,75.258,0,0,1-6.75,5c-5.21,3.55-10.14,6.9-12.26,12.41a30.258,30.258,0,0,0-1.41,9.42c-.14,3.41-.29,6.93-1.64,10.14a28.8,28.8,0,0,1-5,7.31,45.919,45.919,0,0,0-3.35,4.27c-3.69,5.56-4.71,12.45-5.7,19.12-.13.86-.25,1.71-.38,2.56-1.16,7.43-3.15,15.72-9.18,20.88a15.48,15.48,0,0,1-9.92,3.47Zm-55-122.51a9.39,9.39,0,0,1,2.42.31c3.17.84,5.69,3.21,7.75,5.42,14.93,16.08,23.3,40.4,24.2,70.32v1c.11,4.2.23,8.54,1.77,12.42a36.732,36.732,0,0,0,3.34,6c1.66,2.61,3.37,5.3,4.1,8.39a27.868,27.868,0,0,1,.55,5.22,18.43,18.43,0,0,0,1.2,6.94,9.26,9.26,0,0,0,6.7,5,14.47,14.47,0,0,0,12.14-3c5.76-4.94,7.69-13,8.81-20.24l.39-2.54c1-6.79,2-13.8,5.86-19.56a47.485,47.485,0,0,1,3.43-4.37,27.73,27.73,0,0,0,4.85-7c1.27-3,1.41-6.46,1.56-9.77s.28-6.65,1.48-9.76c2.24-5.82,7.53-9.43,12.65-12.91a72.685,72.685,0,0,0,6.65-4.91c4.19-3.62,6.76-10.29,5.86-15.18a7.1,7.1,0,0,0-4.62-5.7,15.18,15.18,0,0,0-4.68-.65,15.68,15.68,0,0,1-5.16-.77c-4.23-1.64-6.2-6.3-7.72-10.53l-11.52-32.2c-2.26-6.3-5.68-13.66-12.2-14.57-2.49-.35-4.91.34-7.48,1.06-1.23.34-2.5.7-3.77.93-5.28,1-11.65-3.17-18.39-7.55-7-4.53-14.21-9.22-19.84-7.6-2.77.79-5,3-6.76,6.83l-.64,1.38-.36-1.48a3.84,3.84,0,0,0-3.44-3,10.33,10.33,0,0,0-9.49,4.68,38.788,38.788,0,0,0-2.61,5.92c-1.37,3.68-2.8,7.48-6,9.88a21.15,21.15,0,0,1-5.54,2.67c-2.47.91-4.8,1.77-6.4,3.62-1.92,2.22-2.32,5.3-2.61,8.79l-1.52,18.4c-.37,4.42-.82,9.93,1.63,14.25a9.6,9.6,0,0,0,6.64,4.58,5.92,5.92,0,0,0,5.06-1.34,12,12,0,0,0,2.22-3.19,20.09,20.09,0,0,1,1.48-2.42,10.12,10.12,0,0,1,8.03-3.77Z"
                    fill="#717272"
                />
                <g id="Group_2" data-name="Group 2" opacity="0.6">
                    <path
                        id="Path_25"
                        data-name="Path 25"
                        d="M91.17,181.31h0v.93c0,1,0,2-.05,3,0-1,0-2,.05-3A4.132,4.132,0,0,1,91.17,181.31Z"
                        fill="#263238"
                    />
                </g>
                <g id="Group_3" data-name="Group 3" opacity="0.6">
                    <path
                        id="Path_26"
                        data-name="Path 26"
                        d="M91.05,190.8v2.46h0C91.07,192.45,91.07,191.62,91.05,190.8Z"
                        fill="#263238"
                    />
                </g>
                <path
                    id="Path_27"
                    data-name="Path 27"
                    d="M114.23,201.27l-1-.16c-3-.32-6.43-.48-8-2.94-1.9-2.85,0-7.09-2-9.9-1-1.46-2.78-2.1-4.22-3.14s-2.66-2.94-1.78-4.49c.72-1.31,2.58-1.57,3.52-2.77a2.73,2.73,0,0,0,0-3.34c-3.05-3.6-6.44,3.74-8.12,5.47a13,13,0,0,1-1.36,1.28h0v.93c0,1,0,2-.05,3s-.06,2-.06,3v4.93a29,29,0,0,1,5.21,2.57c3.28,1.89,6.93,4.4,7.15,8.19a3.12,3.12,0,0,0,.34,1.79,2.61,2.61,0,0,0,1.58.8,47.44,47.44,0,0,0,8.56,1.2"
                    fill="#f3725f"
                />
                <path
                    id="Path_28"
                    data-name="Path 28"
                    d="M113.93,207.81c.06,3.39.3,6.94.24,10.3-.08,4.88-1.68,9.71-1.14,14.54.77,6.83,5.52,12.44,9.66,17.93,15.74,21,24.41,46.25,33.62,71h0c1.7,1.36,3.44,2.64,5.2,3.89,1.39,1,2.79,2,4.21,2.94s2.85,1.89,4.3,2.8c1,.64,2,1.26,3.07,1.87-.13-.29-.27-.56-.4-.85-3.71-8.14-3.92-19.89,4.06-23.91,1.52-.78,3.25-1.21,4.51-2.38,3.55-3.36.64-10.3,4.19-13.66,2-1.87,5.12-1.74,7.6-2.86,4.46-2.05,5.9-7.76,5.55-12.67s-2-9.74-1.41-14.63c.88-7.39,6.64-14.89,3.33-21.56-3.71-7.44-14.51-6.24-22.12-9.58-10.62-4.67-13.9-17.85-20.84-27.16-6.22-8.33-20.73-17.48-31.78-15-8,1.81-10.75,6.59-11.58,12.46"
                    fill="#f3725f"
                />
                <path
                    id="Path_29"
                    data-name="Path 29"
                    d="M101.61,139.23c3.14-2.7,8.59-3,11,.34,1.73,2.41,1.33,5.69.88,8.62-.62,3.95-1.23,7.9-1.87,11.85a6.12,6.12,0,0,0,.16,3.55c1.17,2.51,5.28,2,6.86-.21s1.41-5.31,1-8-1-5.63.08-8.19c2.67-6.35,12.15-5.39,17.64-9.52,3.42-2.57,4.94-6.86,7-10.62s5.42-7.53,9.68-7.34c1.45,0,2.86.58,4.3.53,4.22-.13,6.67-6.3,3.68-9.29a10.23,10.23,0,0,1-1.86-1.92c-.75-1.41.05-3.23,1.33-4.19a10,10,0,0,1,4.48-1.44q5.42-.87,10.81-1.7c4-.62,9.07-2.67,8.51-6.65-.48-3.44-5.15-5-5.84-8.41a11.6,11.6,0,0,0-.45-2.5c-1.1-2.19-4.38-1.31-6.49-.14-.85-3.17-5.39-4.61-7.92-2.53-2.14,1.76-2.41,4.85-3.15,7.5-1.76,6.4-6.86,11.26-11.72,15.77-1.63,1.49-3.47,3.09-5.68,3.2s-4.54-2.27-3.52-4.22c.69-1.33,2.61-2.1,2.42-3.6-.26-1.87-3.52-1.73-4.16-3.52,1.28-5.29,7.34-7.47,12-10.3A29.05,29.05,0,0,0,163,71.21a3.83,3.83,0,0,0,.16-3.1c-.69-1.33-2.48-1.55-4-1.55-3.58,0-8,.43-9.34,3.77-.7,1.79-.19,3.81-.61,5.68-1.26,5.55-8.86,6.17-13.51,9.47-1.81,1.28-3.23,3.07-5.23,4.06-2.16,1-4.69,1-7.1,1.15a11.331,11.331,0,0,0-1.28.13c-1.46,2-2.88,4.12-4.24,6.24s-2.68,4.26-4,6.44a166.22,166.22,0,0,0-14.62,32.61q-2,6-3.46,12.16-1.5,6.165-2.55,12.52c1.66-3.42,2.41-7.63,3-10.62C97.18,146.14,98.48,141.92,101.61,139.23Z"
                    fill="#f3725f"
                />
                <path
                    id="Path_30"
                    data-name="Path 30"
                    d="M243.05,61c1.6-2.1,1.13-5.1,2.16-7.52,1.72-4,7.06-5.45,8.91-9.41.71-1.52.88-3.38,2.13-4.51,1-.94,2.57-1.13,3.68-2,2.48-1.91,1.45-6.24-1.19-7.93-6.61-4.22-18.78.66-24.5,4.8-7.34,5.31-14.53,11.71-24.31,11.09-2.69-.17-5.49-.91-8,0S197.83,50.34,200,52c1.21.89,2.93.64,4.29,1.27,2.52,1.17,2.77,4.81,1.54,7.3s-3.44,4.36-4.9,6.72A12.8,12.8,0,0,0,199.12,75a7,7,0,0,0,2.29,5c3,2.43,7.66.35,10.24-2.57s4.35-6.68,7.69-8.68a19.08,19.08,0,0,1,5.48-1.91l12.75-3C239.6,63.26,241.79,62.67,243.05,61Z"
                    fill="#f3725f"
                />
                <g id="Group_4" data-name="Group 4" opacity="0.6">
                    <path
                        id="Path_31"
                        data-name="Path 31"
                        d="M428.15,186q0-3.64-.22-7.24.19,3.6.22,7.24c.05.77.05,1.54.05,2.32,0,3.73-.13,7.42-.35,11.1.22-3.68.35-7.37.35-11.1C428.2,187.55,428.2,186.78,428.15,186Z"
                        fill="#263238"
                    />
                </g>
                <g id="Group_5" data-name="Group 5" opacity="0.6">
                    <path
                        id="Path_32"
                        data-name="Path 32"
                        d="M417.61,129.43q1.2,3.21,2.26,6.45-1.06-3.24-2.26-6.45Z"
                        fill="#263238"
                    />
                </g>
                <path
                    id="Path_33"
                    data-name="Path 33"
                    d="M428.15,186q0-3.64-.22-7.24t-.56-7.15c-.18-1.92-.4-3.81-.66-5.71s-.56-4-.89-6a164.512,164.512,0,0,0-3.94-17.51q-.94-3.3-2-6.55t-2.26-6.45h0c-.86-1.6-1.76-3.18-2.75-4.73-9.37-14.83-23-26.47-33.28-40.66-3.36-4.62-6-8.44-11.93-9.34-8.8-1.36-13.26,3.65-19.5-4.7-1.68-2.24-4.62-4.32-7.1-3,.64,1.79,1.31,3.58,1.95,5.39a2.68,2.68,0,0,1,.21,1.18c-.13,1.25-2,1.6-3.07.9s-1.6-2-2.35-3c-2.77-4-9.28-4.49-12.67-1a4.86,4.86,0,0,0-2.8-4,5.79,5.79,0,0,1-7.26,4.67c-.51-1.63,2.4-1.92,3.41-3.31s-.18-3.12-1.38-4.22a18.6,18.6,0,0,0-11.61-4.51c-2.7-.05-5.6.46-8-.93-1.36-.8-2.32-2.14-3.71-2.91-3-1.68-6.67-.13-9.66,1.52-4.09,2.27-8.3,5.12-9.74,9.58s1.76,10.43,6.4,9.87c1.18-.16,2.4-.72,3.55-.4,1.66.46,2.4,2.38,2.54,4.09s-.06,3.49.77,5,3.23,2.24,4.16.82c2.19-2.08,1.92-5.57,1.36-8.53s-1.14-6.3.62-8.73,6.86-1.66,6.51,1.33c-.21,1.76-2.22,3-2.14,4.83s2.3,2.78,4.11,2.7,3.66-.72,5.42-.27,3.2,2.75,1.92,4.06c-2.21,2.51-8-1.79-9.12,1.33-.32.8,0,1.71-.08,2.56-.22,2.62-3.5,3.58-6.12,3.9s-5.39.56-7.76-.56-4-4.24-2.64-6.48c-1.34-1-3.36,0-4.08,1.49a8.61,8.61,0,0,0-.3,4.86c-2.77-.62-5.26,1.73-6.83,4.05s-3.12,5.07-5.82,5.9-6.45-.29-7.87,2.16c-1.84,3.2,3.5,7.26,1.63,10.43-1.07,1.79-3.63,1.74-5.66,2.3-5.36,1.52-7.23,9.37-3.57,13.56s11,3.94,14.83-.06c2.7-2.75,3.79-6.62,5.74-9.92s5.63-6.28,9.31-5.21a11.36,11.36,0,0,1,3.82,2.4c1.79,1.5,3.57,3,5.36,4.51,1.15,1,2.4,2.16,2.3,3.66-.11,1.2-1,2.13-1.44,3.25-1.12,3.23,3.55,6.3,6.48,4.54s3.26-6.27,1.25-9c-2.77-3.84-9-5.76-8.88-10.51,3.2-2.61,8.24.13,10.11,3.84s1.92,8.06,3.5,11.88,6,7.23,9.66,5.36c-1-3.31-1.9-6.59-2.86-9.87,2.35-1.76,5,3.36,7.85,2.51,1.71-.54,1.92-3,1.17-4.65s-2.05-3-2.37-4.83c-.54-3.25,3.09-6.16,6.37-5.63s5.64,3.66,6.25,6.89a15.172,15.172,0,0,0,.85,3.81c1.23,2.57,4.41,3.34,7,4.41s5.36,3.71,4.27,6.32c-.51,1.15-1.71,2.24-1.28,3.42s1.95,1.49,1.95,2.61c0,.75-.8,1.26-1.5,1.55-1.76.72-3.68,1-5.39,1.79s-3.25,2.45-3.12,4.32c.21,2.67,3.39,4,4.88,6.16s1.23,4.91,2.14,7.32c.85,2.21,2.61,3.95,4,5.84,4.43,6,5.47,13.8,7.63,20.95,1,3.23,2.72,6.83,6,7.44,1.82.32,3.63-.37,5.34-1,4.77-1.89,9.74-3.92,13.07-7.79s4.49-10.22,1-14a2.7,2.7,0,0,0-1.62-1,5,5,0,0,0-2.51.88c-2.43,1.12-5.42.19-7.45-1.6s-3.23-4.24-4.43-6.64c-1.3-2.64-2.61-5.31-3.95-8,1.58-1.33,4.09-.77,5.71.53s2.59,3.21,3.9,4.81c4,5,10.51,7.15,16.84,7.89a16.421,16.421,0,0,1,4.75,1c4.72,2.16,6.08,9.13,11.07,10.62,1.39.43,2.94.35,4.25,1,2,.94,3,3.18,3.54,5.29,1.1,3.92,1.47,8.06,3.13,11.79s5,7.13,9,7.18a9.74,9.74,0,0,0,6.77-3h0c.22-3.68.35-7.37.35-11.1A9.938,9.938,0,0,0,428.15,186Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_34"
                    data-name="Path 34"
                    d="M363.81,222.77c6.66-5.75,9.35-18.77,1.08-21.78-3.13-1.14-6.74-.22-9.84-1.42-4.05-1.57-5.94-6.12-7.4-10.21q-5.77-16.1-11.53-32.2c-2.32-6.47-5.83-14-12.63-14.92-3.85-.53-7.59,1.3-11.42,2-13.18,2.4-35.34-29.49-45.37-8-1.4-5.83-10.88-3.64-13.91,1.54s-3.67,12.05-8.47,15.64c-3.67,2.75-9,2.91-12,6.38-2.1,2.43-2.46,5.88-2.73,9.08q-.77,9.21-1.52,18.41c-.41,5-.75,10.24,1.7,14.56s8.85,6.72,12.51,3.37c1.69-1.54,2.4-3.87,3.78-5.69a9.58,9.58,0,0,1,9.84-3.4c3,.8,5.39,3,7.5,5.28,17.15,18.47,23.3,44.77,24.05,70,.14,4.62.15,9.36,1.84,13.65,2,5,6.18,9.09,7.42,14.35.94,4,.05,8.49,1.79,12.26,3.19,6.95,13.86,7.25,19.66,2.27s7.83-13,9-20.56,1.94-15.52,6.17-21.9c2.62-4,6.48-7.11,8.32-11.48,2.56-6.12.66-13.37,3-19.55C347.82,232.17,357.16,228.53,363.81,222.77Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_35"
                    data-name="Path 35"
                    d="M156.31,321.54h0c1.7,1.36,3.44,2.64,5.2,3.89,1.39,1,2.79,2,4.21,2.94s2.85,1.89,4.3,2.8c1,.64,2,1.26,3.07,1.87-.13-.29-.27-.56-.4-.85-3.71-8.14-3.92-19.89,4.06-23.91,1.52-.78,3.25-1.21,4.51-2.38,3.55-3.36.64-10.3,4.19-13.66,2-1.87,5.12-1.74,7.6-2.86,4.46-2.05,5.9-7.76,5.55-12.67s-2-9.74-1.41-14.63c.88-7.39,6.64-14.89,3.33-21.56-3.71-7.44-14.51-6.24-22.12-9.58-10.62-4.67-13.9-17.85-20.84-27.16-6.22-8.33-20.73-17.48-31.78-15-8,1.81-10.75,6.59-11.58,12.46l-1-.16c-3-.32-6.43-.48-8-2.94-1.9-2.85,0-7.09-2-9.9-1-1.46-2.78-2.1-4.22-3.14s-2.66-2.94-1.78-4.49c.72-1.31,2.58-1.57,3.52-2.77a2.73,2.73,0,0,0,0-3.34c-3.05-3.6-6.44,3.74-8.12,5.47a13,13,0,0,1-1.36,1.28h0v.93c0,1,0,2-.05,3s-.06,2-.06,3v6.11a167.93,167.93,0,0,0,10.73,53.5,161.42,161.42,0,0,0,10.3,22.1c1.65,3.07,3.47,6.08,5.36,9,2.35,3.66,4.8,7.23,7.45,10.68,2.45,3.31,5.07,6.53,7.81,9.63a166.445,166.445,0,0,0,11.93,12.27q5.56,5.2,11.61,9.88"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M101.61,139.23c3.14-2.7,8.59-3,11,.34,1.73,2.41,1.33,5.69.88,8.62-.62,3.95-1.23,7.9-1.87,11.85a6.12,6.12,0,0,0,.16,3.55c1.17,2.51,5.28,2,6.86-.21s1.41-5.31,1-8-1-5.63.08-8.19c2.67-6.35,12.15-5.39,17.64-9.52,3.42-2.57,4.94-6.86,7-10.62s5.42-7.53,9.68-7.34c1.45,0,2.86.58,4.3.53,4.22-.13,6.67-6.3,3.68-9.29a10.23,10.23,0,0,1-1.86-1.92c-.75-1.41.05-3.23,1.33-4.19a10,10,0,0,1,4.48-1.44q5.42-.87,10.81-1.7c4-.62,9.07-2.67,8.51-6.65-.48-3.44-5.15-5-5.84-8.41a11.6,11.6,0,0,0-.45-2.5c-1.1-2.19-4.38-1.31-6.49-.14-.85-3.17-5.39-4.61-7.92-2.53-2.14,1.76-2.41,4.85-3.15,7.5-1.76,6.4-6.86,11.26-11.72,15.77-1.63,1.49-3.47,3.09-5.68,3.2s-4.54-2.27-3.52-4.22c.69-1.33,2.61-2.1,2.42-3.6-.26-1.87-3.52-1.73-4.16-3.52,1.28-5.29,7.34-7.47,12-10.3A29.05,29.05,0,0,0,163,71.21a3.83,3.83,0,0,0,.16-3.1c-.69-1.33-2.48-1.55-4-1.55-3.58,0-8,.43-9.34,3.77-.7,1.79-.19,3.81-.61,5.68-1.26,5.55-8.86,6.17-13.51,9.47-1.81,1.28-3.23,3.07-5.23,4.06-2.16,1-4.69,1-7.1,1.15a11.331,11.331,0,0,0-1.28.13c-1.46,2-2.88,4.12-4.24,6.24s-2.68,4.26-4,6.44a166.22,166.22,0,0,0-14.62,32.61q-2,6-3.46,12.16-1.5,6.165-2.55,12.52c1.66-3.42,2.41-7.63,3-10.62C97.18,146.14,98.48,141.92,101.61,139.23Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M243.05,61c1.6-2.1,1.13-5.1,2.16-7.52,1.72-4,7.06-5.45,8.91-9.41.71-1.52.88-3.38,2.13-4.51,1-.94,2.57-1.13,3.68-2,2.48-1.91,1.45-6.24-1.19-7.93-6.61-4.22-18.78.66-24.5,4.8-7.34,5.31-14.53,11.71-24.31,11.09-2.69-.17-5.49-.91-8,0S197.83,50.34,200,52c1.21.89,2.93.64,4.29,1.27,2.52,1.17,2.77,4.81,1.54,7.3s-3.44,4.36-4.9,6.72A12.8,12.8,0,0,0,199.12,75a7,7,0,0,0,2.29,5c3,2.43,7.66.35,10.24-2.57s4.35-6.68,7.69-8.68a19.08,19.08,0,0,1,5.48-1.91l12.75-3C239.6,63.26,241.79,62.67,243.05,61Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M428.15,186q0-3.64-.22-7.24t-.56-7.15c-.18-1.92-.4-3.81-.66-5.71s-.56-4-.89-6a164.512,164.512,0,0,0-3.94-17.51q-.94-3.3-2-6.55t-2.26-6.45h0c-.86-1.6-1.76-3.18-2.75-4.73-9.37-14.83-23-26.47-33.28-40.66-3.36-4.62-6-8.44-11.93-9.34-8.8-1.36-13.26,3.65-19.5-4.7-1.68-2.24-4.62-4.32-7.1-3,.64,1.79,1.31,3.58,1.95,5.39a2.68,2.68,0,0,1,.21,1.18c-.13,1.25-2,1.6-3.07.9s-1.6-2-2.35-3c-2.77-4-9.28-4.49-12.67-1a4.86,4.86,0,0,0-2.8-4,5.79,5.79,0,0,1-7.26,4.67c-.51-1.63,2.4-1.92,3.41-3.31s-.18-3.12-1.38-4.22a18.6,18.6,0,0,0-11.61-4.51c-2.7-.05-5.6.46-8-.93-1.36-.8-2.32-2.14-3.71-2.91-3-1.68-6.67-.13-9.66,1.52-4.09,2.27-8.3,5.12-9.74,9.58s1.76,10.43,6.4,9.87c1.18-.16,2.4-.72,3.55-.4,1.66.46,2.4,2.38,2.54,4.09s-.06,3.49.77,5,3.23,2.24,4.16.82c2.19-2.08,1.92-5.57,1.36-8.53s-1.14-6.3.62-8.73,6.86-1.66,6.51,1.33c-.21,1.76-2.22,3-2.14,4.83s2.3,2.78,4.11,2.7,3.66-.72,5.42-.27,3.2,2.75,1.92,4.06c-2.21,2.51-8-1.79-9.12,1.33-.32.8,0,1.71-.08,2.56-.22,2.62-3.5,3.58-6.12,3.9s-5.39.56-7.76-.56-4-4.24-2.64-6.48c-1.34-1-3.36,0-4.08,1.49a8.61,8.61,0,0,0-.3,4.86c-2.77-.62-5.26,1.73-6.83,4.05s-3.12,5.07-5.82,5.9-6.45-.29-7.87,2.16c-1.84,3.2,3.5,7.26,1.63,10.43-1.07,1.79-3.63,1.74-5.66,2.3-5.36,1.52-7.23,9.37-3.57,13.56s11,3.94,14.83-.06c2.7-2.75,3.79-6.62,5.74-9.92s5.63-6.28,9.31-5.21a11.36,11.36,0,0,1,3.82,2.4c1.79,1.5,3.57,3,5.36,4.51,1.15,1,2.4,2.16,2.3,3.66-.11,1.2-1,2.13-1.44,3.25-1.12,3.23,3.55,6.3,6.48,4.54s3.26-6.27,1.25-9c-2.77-3.84-9-5.76-8.88-10.51,3.2-2.61,8.24.13,10.11,3.84s1.92,8.06,3.5,11.88,6,7.23,9.66,5.36c-1-3.31-1.9-6.59-2.86-9.87,2.35-1.76,5,3.36,7.85,2.51,1.71-.54,1.92-3,1.17-4.65s-2.05-3-2.37-4.83c-.54-3.25,3.09-6.16,6.37-5.63s5.64,3.66,6.25,6.89a15.172,15.172,0,0,0,.85,3.81c1.23,2.57,4.41,3.34,7,4.41s5.36,3.71,4.27,6.32c-.51,1.15-1.71,2.24-1.28,3.42s1.95,1.49,1.95,2.61c0,.75-.8,1.26-1.5,1.55-1.76.72-3.68,1-5.39,1.79s-3.25,2.45-3.12,4.32c.21,2.67,3.39,4,4.88,6.16s1.23,4.91,2.14,7.32c.85,2.21,2.61,3.95,4,5.84,4.43,6,5.47,13.8,7.63,20.95,1,3.23,2.72,6.83,6,7.44,1.82.32,3.63-.37,5.34-1,4.77-1.89,9.74-3.92,13.07-7.79s4.49-10.22,1-14a2.7,2.7,0,0,0-1.62-1,5,5,0,0,0-2.51.88c-2.43,1.12-5.42.19-7.45-1.6s-3.23-4.24-4.43-6.64c-1.3-2.64-2.61-5.31-3.95-8,1.58-1.33,4.09-.77,5.71.53s2.59,3.21,3.9,4.81c4,5,10.51,7.15,16.84,7.89a16.421,16.421,0,0,1,4.75,1c4.72,2.16,6.08,9.13,11.07,10.62,1.39.43,2.94.35,4.25,1,2,.94,3,3.18,3.54,5.29,1.1,3.92,1.47,8.06,3.13,11.79s5,7.13,9,7.18a9.74,9.74,0,0,0,6.77-3h0c.22-3.68.35-7.37.35-11.1A9.938,9.938,0,0,0,428.15,186Z"
                    fill="#e4e3e3"
                />
                <g id="Group_6" data-name="Group 6" opacity="0.2">
                    <path
                        id="Path_39"
                        data-name="Path 39"
                        d="M359.9,256c-2.51.49-3,2-4.38,3.83-1.78,2.42-4.32,4.85-5.94,7.24-2.74,4.05-.27,10.37-3.88,13.78a29.286,29.286,0,0,0-2.35,1.92,4.27,4.27,0,0,0,.87,5.89,5.78,5.78,0,0,0,6.28.11,9.19,9.19,0,0,0,3.85-5.26c.48-1.53.75-3.26,1.95-4.31,2.07-1.81,5.28-.47,8-.85C375.86,276.73,370.89,253.83,359.9,256Z"
                    />
                </g>
                <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M105.21,269.15a17.408,17.408,0,0,1,2.61-.36,19.006,19.006,0,0,1,2.58-.53,4.08,4.08,0,0,1-2.49,1.07,4.15,4.15,0,0,1-2.7-.18Z"
                    fill="#717272"
                />
                <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M96.08,264.11c.13-.11,1,.72,2.09,1.64s2.09,1.59,2,1.73a4.8,4.8,0,0,1-2.36-1.3A5.356,5.356,0,0,1,96.08,264.11Z"
                    fill="#717272"
                />
                <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M92,254.47c.07,0,.18.28.28.75s.2,1.12.38,1.82a12.149,12.149,0,0,1,.57,2.59,4.63,4.63,0,0,1-1.11-2.46,8.23,8.23,0,0,1-.23-1.91C91.89,254.77,91.92,254.47,92,254.47Z"
                    fill="#717272"
                />
                <path
                    id="Path_43"
                    data-name="Path 43"
                    d="M93.53,244a8,8,0,0,1-.49,2.62,8.89,8.89,0,0,1-.81,2.54,5.47,5.47,0,0,1,.27-2.68A5.67,5.67,0,0,1,93.53,244Z"
                    fill="#717272"
                />
                <path
                    id="Path_44"
                    data-name="Path 44"
                    d="M98.08,234.37a6.38,6.38,0,0,1-1,2.48c-.69,1.29-1.36,2.29-1.5,2.22a6.49,6.49,0,0,1,1-2.48A7.525,7.525,0,0,1,98.08,234.37Z"
                    fill="#717272"
                />
                <path
                    id="Path_45"
                    data-name="Path 45"
                    d="M103.74,225.33a6.64,6.64,0,0,1-1.21,2.39c-.8,1.24-1.55,2.17-1.68,2.09a6.6,6.6,0,0,1,1.21-2.39C102.86,226.18,103.61,225.25,103.74,225.33Z"
                    fill="#717272"
                />
                <path
                    id="Path_46"
                    data-name="Path 46"
                    d="M109.86,216.61a6.47,6.47,0,0,1-1.33,2.32c-.86,1.2-1.66,2.09-1.79,2a6.79,6.79,0,0,1,1.34-2.32C108.94,217.41,109.74,216.52,109.86,216.61Z"
                    fill="#717272"
                />
                <path
                    id="Path_47"
                    data-name="Path 47"
                    d="M116.42,208.21a6.72,6.72,0,0,1-1.45,2.25c-.92,1.15-1.76,2-1.88,1.91a6.6,6.6,0,0,1,1.45-2.26C115.46,209,116.3,208.11,116.42,208.21Z"
                    fill="#717272"
                />
                <path
                    id="Path_48"
                    data-name="Path 48"
                    d="M123.37,200.13a6.71,6.71,0,0,1-1.55,2.18c-1,1.1-1.86,1.92-2,1.82s.58-1.08,1.55-2.19S123.26,200,123.37,200.13Z"
                    fill="#717272"
                />
                <path
                    id="Path_49"
                    data-name="Path 49"
                    d="M130.68,192.37c.11.11-.63,1.06-1.65,2.11a8.012,8.012,0,0,1-2,1.73,7.826,7.826,0,0,1,1.65-2.11C129.7,193.04,130.57,192.27,130.68,192.37Z"
                    fill="#717272"
                />
                <path
                    id="Path_50"
                    data-name="Path 50"
                    d="M138.32,184.94c.11.12-.67,1-1.73,2s-2,1.75-2.13,1.64.67-1,1.74-2S138.22,184.83,138.32,184.94Z"
                    fill="#717272"
                />
                <path
                    id="Path_51"
                    data-name="Path 51"
                    d="M146.26,177.83c.1.11-.72,1-1.82,2a6.66,6.66,0,0,1-2.18,1.56c-.11-.12.71-1,1.81-2S146.16,177.71,146.26,177.83Z"
                    fill="#717272"
                />
                <path
                    id="Path_52"
                    data-name="Path 52"
                    d="M154.46,171c.09.12-.75,1-1.89,1.9s-2.14,1.58-2.24,1.46.74-1,1.89-1.9A7.639,7.639,0,0,1,154.46,171Z"
                    fill="#717272"
                />
                <path
                    id="Path_53"
                    data-name="Path 53"
                    d="M162.89,164.5c.09.12-.78.94-1.95,1.83a6.68,6.68,0,0,1-2.29,1.39c-.1-.12.78-.94,1.95-1.83S162.8,164.37,162.89,164.5Z"
                    fill="#717272"
                />
                <path
                    id="Path_54"
                    data-name="Path 54"
                    d="M171.53,158.26c.09.12-.81.92-2,1.77a6.49,6.49,0,0,1-2.33,1.31c-.09-.12.81-.91,2-1.77A6.58,6.58,0,0,1,171.53,158.26Z"
                    fill="#717272"
                />
                <path
                    id="Path_55"
                    data-name="Path 55"
                    d="M180.36,152.28c.09.13-.84.9-2.06,1.71a6.64,6.64,0,0,1-2.37,1.25c-.09-.13.83-.89,2.06-1.71a6.64,6.64,0,0,1,2.37-1.25Z"
                    fill="#717272"
                />
                <path
                    id="Path_56"
                    data-name="Path 56"
                    d="M189.35,146.56c.08.13-.86.87-2.11,1.65a6.62,6.62,0,0,1-2.4,1.18c-.08-.13.86-.87,2.11-1.65a6.5,6.5,0,0,1,2.4-1.18Z"
                    fill="#717272"
                />
                <path
                    id="Path_57"
                    data-name="Path 57"
                    d="M198.49,141.06c.08.13-.89.85-2.15,1.6a6.77,6.77,0,0,1-2.43,1.12c-.08-.13.88-.85,2.15-1.6A6.62,6.62,0,0,1,198.49,141.06Z"
                    fill="#717272"
                />
                <path
                    id="Path_58"
                    data-name="Path 58"
                    d="M207.75,135.78c.08.13-.9.83-2.19,1.55a6.49,6.49,0,0,1-2.45,1.06c-.08-.13.9-.82,2.18-1.55a6.77,6.77,0,0,1,2.46-1.06Z"
                    fill="#717272"
                />
                <path
                    id="Path_59"
                    data-name="Path 59"
                    d="M217.12,130.7c.08.14-.92.81-2.21,1.5a6.7,6.7,0,0,1-2.49,1c-.07-.14.92-.81,2.22-1.51a6.829,6.829,0,0,1,2.48-.99Z"
                    fill="#717272"
                />
                <path
                    id="Path_60"
                    data-name="Path 60"
                    d="M226.59,125.81a6.68,6.68,0,0,1-2.24,1.46,6.49,6.49,0,0,1-2.5,1,6.68,6.68,0,0,1,2.24-1.46,6.55,6.55,0,0,1,2.5-1Z"
                    fill="#717272"
                />
                <path
                    id="Path_61"
                    data-name="Path 61"
                    d="M236.15,121.08a7.326,7.326,0,0,1-2.27,1.42,6.49,6.49,0,0,1-2.52.92c-.07-.14.95-.77,2.27-1.42A6.54,6.54,0,0,1,236.15,121.08Z"
                    fill="#717272"
                />
                <path
                    id="Path_62"
                    data-name="Path 62"
                    d="M245.78,116.5a12.68,12.68,0,0,1-4.83,2.27A13.29,13.29,0,0,1,245.78,116.5Z"
                    fill="#717272"
                />
                <path
                    id="Path_63"
                    data-name="Path 63"
                    d="M255.48,112.06a6.75,6.75,0,0,1-2.32,1.36,6.57,6.57,0,0,1-2.54.85,12.78,12.78,0,0,1,4.86-2.21Z"
                    fill="#717272"
                />
                <path
                    id="Path_64"
                    data-name="Path 64"
                    d="M265.23,107.77a6.66,6.66,0,0,1-2.33,1.32,6.79,6.79,0,0,1-2.56.81,6.77,6.77,0,0,1,2.34-1.32,6.61,6.61,0,0,1,2.55-.81Z"
                    fill="#717272"
                />
                <path
                    id="Path_65"
                    data-name="Path 65"
                    d="M275.07,103.65a6.8,6.8,0,0,1-2.36,1.27,6.3,6.3,0,0,1-2.57.76,6.56,6.56,0,0,1,2.36-1.27,6.7,6.7,0,0,1,2.57-.76Z"
                    fill="#717272"
                />
                <path
                    id="Path_66"
                    data-name="Path 66"
                    d="M285,99.76a6.82,6.82,0,0,1-2.4,1.24,6.56,6.56,0,0,1-2.58.69,6.67,6.67,0,0,1,2.38-1.21,6.54,6.54,0,0,1,2.6-.72Z"
                    fill="#717272"
                />
                <path
                    id="Path_67"
                    data-name="Path 67"
                    d="M295,96.13a13,13,0,0,1-5,1.78,6.51,6.51,0,0,1,2.42-1.15A6.37,6.37,0,0,1,295,96.13Z"
                    fill="#717272"
                />
                <path
                    id="Path_68"
                    data-name="Path 68"
                    d="M305.14,92.81a6.41,6.41,0,0,1-2.45,1.07,6.77,6.77,0,0,1-2.63.55,6.71,6.71,0,0,1,2.46-1.08A6.64,6.64,0,0,1,305.14,92.81Z"
                    fill="#717272"
                />
                <path
                    id="Path_69"
                    data-name="Path 69"
                    d="M315.38,89.85a13,13,0,0,1-5.13,1.43,13,13,0,0,1,5.13-1.43Z"
                    fill="#717272"
                />
                <path
                    id="Path_70"
                    data-name="Path 70"
                    d="M325.73,87.3a6.66,6.66,0,0,1-2.53.88,6.74,6.74,0,0,1-2.65.34,6.39,6.39,0,0,1,2.53-.88A6.53,6.53,0,0,1,325.73,87.3Z"
                    fill="#717272"
                />
                <path
                    id="Path_71"
                    data-name="Path 71"
                    d="M336.18,85.2a6.55,6.55,0,0,1-2.57.77,6.7,6.7,0,0,1-2.67.22,12.86,12.86,0,0,1,5.24-1Z"
                    fill="#717272"
                />
                <path
                    id="Path_72"
                    data-name="Path 72"
                    d="M346.72,83.62a6.69,6.69,0,0,1-2.6.64,6.62,6.62,0,0,1-2.68.08,6.72,6.72,0,0,1,2.6-.63,6.51,6.51,0,0,1,2.68-.09Z"
                    fill="#717272"
                />
                <path
                    id="Path_73"
                    data-name="Path 73"
                    d="M357.33,82.59A13.79,13.79,0,0,1,352,83a6.58,6.58,0,0,1,2.64-.51A6.79,6.79,0,0,1,357.33,82.59Z"
                    fill="#717272"
                />
                <path
                    id="Path_74"
                    data-name="Path 74"
                    d="M368,82.26a13.05,13.05,0,0,1-5.33.07,6.31,6.31,0,0,1,2.66-.31A6.69,6.69,0,0,1,368,82.26Z"
                    fill="#717272"
                />
                <path
                    id="Path_75"
                    data-name="Path 75"
                    d="M378.62,82.83a6.79,6.79,0,0,1-2.68.07,6.65,6.65,0,0,1-2.63-.48,13,13,0,0,1,5.31.41Z"
                    fill="#717272"
                />
                <path
                    id="Path_76"
                    data-name="Path 76"
                    d="M389.14,84.52a13,13,0,0,1-5.23-1,13,13,0,0,1,5.23,1Z"
                    fill="#717272"
                />
                <path
                    id="Path_77"
                    data-name="Path 77"
                    d="M399.35,87.58a6.87,6.87,0,0,1-2.62-.6,6.68,6.68,0,0,1-2.43-1.12,6.72,6.72,0,0,1,2.61.6A6.47,6.47,0,0,1,399.35,87.58Z"
                    fill="#717272"
                />
                <path
                    id="Path_78"
                    data-name="Path 78"
                    d="M408.91,92.25a6.6,6.6,0,0,1-2.42-1.13,6.77,6.77,0,0,1-2.24-1.44,6.48,6.48,0,0,1,2.5.95C408,91.4,409,92.12,408.91,92.25Z"
                    fill="#717272"
                />
                <path
                    id="Path_79"
                    data-name="Path 79"
                    d="M416.64,99.53c-.13.09-.95-.76-1.94-1.84a8.383,8.383,0,0,1-1.66-2.09,6.024,6.024,0,0,1,2.07,1.72C416.11,98.42,416.76,99.44,416.64,99.53Z"
                    fill="#717272"
                />
                <path
                    id="Path_80"
                    data-name="Path 80"
                    d="M422.31,108.53a6.79,6.79,0,0,1-1.54-2.2,6.64,6.64,0,0,1-1-2.46c.13-.08.82.9,1.54,2.19a6.519,6.519,0,0,1,1,2.47Z"
                    fill="#717272"
                />
                <path
                    id="Path_81"
                    data-name="Path 81"
                    d="M425.92,118.54a7.281,7.281,0,0,1-1-2.49,7.51,7.51,0,0,1-.57-2.62,5.88,5.88,0,0,1,1.1,2.46,6,6,0,0,1,.47,2.65Z"
                    fill="#717272"
                />
                <path
                    id="Path_82"
                    data-name="Path 82"
                    d="M426.91,129.12a8.379,8.379,0,0,1-.22-2.66,8.291,8.291,0,0,1,.11-2.66,5.569,5.569,0,0,1,.44,2.65,5.489,5.489,0,0,1-.33,2.67Z"
                    fill="#717272"
                />
                <path
                    id="Path_83"
                    data-name="Path 83"
                    d="M424,139.28a9.668,9.668,0,0,1,.93-2.49,8.93,8.93,0,0,1,1.13-2.41,5.25,5.25,0,0,1-.62,2.62,5.08,5.08,0,0,1-1.44,2.28Z"
                    fill="#717272"
                />
                <path
                    id="Path_84"
                    data-name="Path 84"
                    d="M140.34,65a7.79,7.79,0,0,1-.44,2.63,7.69,7.69,0,0,1-.79,2.55,5.71,5.71,0,0,1,.25-2.67,5.7,5.7,0,0,1,.98-2.51Z"
                    fill="#717272"
                />
                <path
                    id="Path_85"
                    data-name="Path 85"
                    d="M145.28,55.63A8.71,8.71,0,0,1,144,57.94c-.8,1.22-1.43,2.22-1.57,2.15a5.28,5.28,0,0,1,1.11-2.45C144.3,56.39,145.17,55.54,145.28,55.63Z"
                    fill="#717272"
                />
                <path
                    id="Path_86"
                    data-name="Path 86"
                    d="M153.51,49c.07.14-.93.77-2.15,1.57a8.84,8.84,0,0,1-2.31,1.32c-.1-.11.75-1,2-1.79a5.36,5.36,0,0,1,2.46-1.1Z"
                    fill="#717272"
                />
                <path
                    id="Path_87"
                    data-name="Path 87"
                    d="M163.71,46.13a7.94,7.94,0,0,1-2.6.61,8.65,8.65,0,0,1-2.65.28,5.52,5.52,0,0,1,2.56-.83,5.72,5.72,0,0,1,2.69-.06Z"
                    fill="#717272"
                />
                <path
                    id="Path_88"
                    data-name="Path 88"
                    d="M174.36,46.26a6.6,6.6,0,0,1-2.68.13A6.72,6.72,0,0,1,169,46a6.46,6.46,0,0,1,2.67-.13A6.69,6.69,0,0,1,174.36,46.26Z"
                    fill="#717272"
                />
                <path
                    id="Path_89"
                    data-name="Path 89"
                    d="M184.93,47.61a12.64,12.64,0,0,1-5.27-.76,13.15,13.15,0,0,1,5.27.76Z"
                    fill="#717272"
                />
                <path
                    id="Path_90"
                    data-name="Path 90"
                    d="M195.46,49.27a13.36,13.36,0,0,1-5.26-.83,12.46,12.46,0,0,1,5.26.83Z"
                    fill="#717272"
                />
                <path
                    id="Path_91"
                    data-name="Path 91"
                    d="M205.87,51.56a7,7,0,0,1-2.65-.36,6.77,6.77,0,0,1-2.53-.9,12.88,12.88,0,0,1,5.18,1.26Z"
                    fill="#717272"
                />
                <path
                    id="Path_92"
                    data-name="Path 92"
                    d="M216.05,54.71A13.2,13.2,0,0,1,211,53a6.48,6.48,0,0,1,2.62.58,6.63,6.63,0,0,1,2.43,1.13Z"
                    fill="#717272"
                />
                <path
                    id="Path_93"
                    data-name="Path 93"
                    d="M226,58.64a6.61,6.61,0,0,1-2.57-.77A6.67,6.67,0,0,1,221,56.58a13.16,13.16,0,0,1,5,2.06Z"
                    fill="#717272"
                />
                <path
                    id="Path_94"
                    data-name="Path 94"
                    d="M235.56,63.27a6.85,6.85,0,0,1-2.51-1c-1.31-.66-2.32-1.31-2.25-1.45a6.77,6.77,0,0,1,2.5,1C234.62,62.49,235.63,63.13,235.56,63.27Z"
                    fill="#717272"
                />
                <path
                    id="Path_95"
                    data-name="Path 95"
                    d="M244.84,68.52a6.78,6.78,0,0,1-2.44-1.11,6.71,6.71,0,0,1-2.16-1.59,6.58,6.58,0,0,1,2.44,1.11C244,67.68,244.92,68.39,244.84,68.52Z"
                    fill="#717272"
                />
                <path
                    id="Path_96"
                    data-name="Path 96"
                    d="M253.79,74.33a6.8,6.8,0,0,1-2.37-1.26c-1.22-.82-2.15-1.58-2.06-1.71a6.64,6.64,0,0,1,2.37,1.25C253,73.43,253.88,74.2,253.79,74.33Z"
                    fill="#717272"
                />
                <path
                    id="Path_97"
                    data-name="Path 97"
                    d="M262.39,80.62a6.83,6.83,0,0,1-2.3-1.38,9.591,9.591,0,0,1-2-1.82,7.718,7.718,0,0,1,2.3,1.37C261.57,79.67,262.48,80.49,262.39,80.62Z"
                    fill="#717272"
                />
                <path
                    id="Path_98"
                    data-name="Path 98"
                    d="M270.67,87.33a6.76,6.76,0,0,1-2.23-1.49c-1.13-.94-2-1.8-1.87-1.92s1.09.55,2.23,1.49S270.77,87.21,270.67,87.33Z"
                    fill="#717272"
                />
                <path
                    id="Path_99"
                    data-name="Path 99"
                    d="M278.65,94.39c-.1.12-1.07-.59-2.16-1.58s-1.89-1.88-1.79-2,1.07.59,2.16,1.58S278.76,94.28,278.65,94.39Z"
                    fill="#717272"
                />
                <path
                    id="Path_100"
                    data-name="Path 100"
                    d="M286.35,101.75c-.1.11-1.05-.63-2.1-1.66a8.023,8.023,0,0,1-1.72-2,7.746,7.746,0,0,1,2.11,1.66C285.7,100.78,286.46,101.64,286.35,101.75Z"
                    fill="#717272"
                />
                <path
                    id="Path_101"
                    data-name="Path 101"
                    d="M293.82,109.36c-.11.11-1-.66-2.05-1.72s-1.77-2-1.66-2.11,1,.66,2.06,1.72S293.93,109.26,293.82,109.36Z"
                    fill="#717272"
                />
                <path
                    id="Path_102"
                    data-name="Path 102"
                    d="M301.08,117.17c-.11.1-1-.69-2-1.77s-1.71-2.05-1.6-2.16,1,.69,2,1.78S301.19,117.07,301.08,117.17Z"
                    fill="#717272"
                />
                <path
                    id="Path_103"
                    data-name="Path 103"
                    d="M308.18,125.13c-.12.1-1-.71-2-1.81s-1.67-2.08-1.55-2.19,1,.71,2,1.82A6.66,6.66,0,0,1,308.18,125.13Z"
                    fill="#717272"
                />
                <path
                    id="Path_104"
                    data-name="Path 104"
                    d="M315.13,133.21c-.11.1-1-.73-1.94-1.84a6.88,6.88,0,0,1-1.52-2.21c.12-.1,1,.72,1.94,1.85S315.25,133.11,315.13,133.21Z"
                    fill="#717272"
                />
                <path
                    id="Path_105"
                    data-name="Path 105"
                    d="M322,141.41c-.12.1-1-.74-1.91-1.88a6.65,6.65,0,0,1-1.48-2.23c.12-.1,1,.74,1.91,1.88A6.82,6.82,0,0,1,322,141.41Z"
                    fill="#717272"
                />
                <path
                    id="Path_106"
                    data-name="Path 106"
                    d="M328.61,149.73c-.12.1-1-.76-1.88-1.91a6.64,6.64,0,0,1-1.43-2.26c.12-.1.95.76,1.87,1.91A6.87,6.87,0,0,1,328.61,149.73Z"
                    fill="#717272"
                />
                <path
                    id="Path_107"
                    data-name="Path 107"
                    d="M335.11,158.18c-.12.1-.95-.78-1.84-2a6.58,6.58,0,0,1-1.39-2.29c.12-.09.94.78,1.83,1.95A6.711,6.711,0,0,1,335.11,158.18Z"
                    fill="#717272"
                />
                <path
                    id="Path_108"
                    data-name="Path 108"
                    d="M341.44,166.76c-.13.09-.93-.8-1.8-2a6.73,6.73,0,0,1-1.35-2.31c.13-.1.93.8,1.8,2a6.63,6.63,0,0,1,1.35,2.31Z"
                    fill="#717272"
                />
                <path
                    id="Path_109"
                    data-name="Path 109"
                    d="M347.58,175.47c-.12.09-.91-.82-1.75-2a6.829,6.829,0,0,1-1.3-2.35c.13-.09.91.82,1.76,2A6.6,6.6,0,0,1,347.58,175.47Z"
                    fill="#717272"
                />
                <path
                    id="Path_110"
                    data-name="Path 110"
                    d="M353.53,184.32c-.13.08-.89-.84-1.7-2.07a6.76,6.76,0,0,1-1.25-2.37c.13-.09.89.84,1.71,2.06a6.63,6.63,0,0,1,1.24,2.38Z"
                    fill="#717272"
                />
                <path
                    id="Path_111"
                    data-name="Path 111"
                    d="M359.28,193.3c-.13.08-.88-.86-1.66-2.11a6.55,6.55,0,0,1-1.19-2.4c.13-.08.87.86,1.66,2.11A6.75,6.75,0,0,1,359.28,193.3Z"
                    fill="#717272"
                />
                <path
                    id="Path_112"
                    data-name="Path 112"
                    d="M364.8,202.42a7,7,0,0,1-1.61-2.15,6.621,6.621,0,0,1-1.12-2.43c.13-.08.85.88,1.6,2.15A6.55,6.55,0,0,1,364.8,202.42Z"
                    fill="#717272"
                />
                <path
                    id="Path_113"
                    data-name="Path 113"
                    d="M370.09,211.67c-.14.08-.83-.9-1.55-2.18a6.91,6.91,0,0,1-1.07-2.46c.14-.08.83.9,1.55,2.18a6.91,6.91,0,0,1,1.07,2.46Z"
                    fill="#717272"
                />
                <path
                    id="Path_114"
                    data-name="Path 114"
                    d="M375.13,221.07c-.14.07-.81-.93-1.49-2.23a6.51,6.51,0,0,1-1-2.49,6.86,6.86,0,0,1,1.49,2.23,6.709,6.709,0,0,1,1,2.49Z"
                    fill="#717272"
                />
                <path
                    id="Path_115"
                    data-name="Path 115"
                    d="M379.9,230.6a6.8,6.8,0,0,1-1.42-2.27,6.61,6.61,0,0,1-.93-2.52,6.87,6.87,0,0,1,1.43,2.27,6.539,6.539,0,0,1,.92,2.52Z"
                    fill="#717272"
                />
                <path
                    id="Path_116"
                    data-name="Path 116"
                    d="M384.4,240.27a12.83,12.83,0,0,1-2.21-4.85,6.52,6.52,0,0,1,1.36,2.31,6.62,6.62,0,0,1,.85,2.54Z"
                    fill="#717272"
                />
                <path
                    id="Path_117"
                    data-name="Path 117"
                    d="M388.6,250.06a12.78,12.78,0,0,1-2.06-4.91,13.21,13.21,0,0,1,2.06,4.91Z"
                    fill="#717272"
                />
                <path
                    id="Path_118"
                    data-name="Path 118"
                    d="M392.49,260a6.32,6.32,0,0,1-1.21-2.39,6.68,6.68,0,0,1-.7-2.58,6.321,6.321,0,0,1,1.21,2.39A6.68,6.68,0,0,1,392.49,260Z"
                    fill="#717272"
                />
                <path
                    id="Path_119"
                    data-name="Path 119"
                    d="M396.05,270a6.58,6.58,0,0,1-1.13-2.43,6.78,6.78,0,0,1-.61-2.61,6.77,6.77,0,0,1,1.13,2.43,6.57,6.57,0,0,1,.61,2.61Z"
                    fill="#717272"
                />
                <path
                    id="Path_120"
                    data-name="Path 120"
                    d="M399.27,280.19a6.48,6.48,0,0,1-1-2.46,6.89,6.89,0,0,1-.52-2.63,6.48,6.48,0,0,1,1.05,2.46A6.67,6.67,0,0,1,399.27,280.19Z"
                    fill="#717272"
                />
                <path
                    id="Path_121"
                    data-name="Path 121"
                    d="M402.13,290.45a12.83,12.83,0,0,1-1.38-5.14,7,7,0,0,1,1,2.5A6.591,6.591,0,0,1,402.13,290.45Z"
                    fill="#717272"
                />
                <path
                    id="Path_122"
                    data-name="Path 122"
                    d="M404.22,300.89a8.23,8.23,0,0,1-.57-2.6,8.12,8.12,0,0,1-.23-2.66,9.39,9.39,0,0,1,.8,5.26Z"
                    fill="#717272"
                />
                <path
                    id="Path_123"
                    data-name="Path 123"
                    d="M402.63,311.34a9.482,9.482,0,0,1,.59-2.59,8.89,8.89,0,0,1,.81-2.54,5.2,5.2,0,0,1-.27,2.68,5.081,5.081,0,0,1-1.13,2.45Z"
                    fill="#717272"
                />
                <path
                    id="Path_124"
                    data-name="Path 124"
                    d="M396.05,319.41c-.08-.15,1-.72,2.06-1.63a14.085,14.085,0,0,0,1.29-1.31c.33-.34.57-.54.63-.49s-.06.32-.32.73a5.929,5.929,0,0,1-1.24,1.49,4.23,4.23,0,0,1-2.42,1.21Z"
                    fill="#717272"
                />
                <path
                    id="Path_125"
                    data-name="Path 125"
                    d="M385.67,321.61a7.621,7.621,0,0,1,2.63-.51,8.3,8.3,0,0,1,2.7-.1,5.57,5.57,0,0,1-2.6.68,5.82,5.82,0,0,1-2.73-.07Z"
                    fill="#717272"
                />
                <path
                    id="Path_126"
                    data-name="Path 126"
                    d="M375,321.17a13,13,0,0,1,5.31.47,6.45,6.45,0,0,1-2.68,0A6.65,6.65,0,0,1,375,321.17Z"
                    fill="#717272"
                />
                <path
                    id="Path_127"
                    data-name="Path 127"
                    d="M366.23,318.72c.08-.13.87.16,1.85.52s1.77.71,1.73.86-.91,0-1.92-.34S366.15,318.86,366.23,318.72Z"
                    fill="#717272"
                />
                <path
                    id="Path_128"
                    data-name="Path 128"
                    d="M200.38,303.41a13,13,0,0,1,4.89,2.11,6.76,6.76,0,0,1-2.56-.8,6.61,6.61,0,0,1-2.33-1.31Z"
                    fill="#717272"
                />
                <path
                    id="Path_129"
                    data-name="Path 129"
                    d="M190.78,298.76a6.58,6.58,0,0,1,2.51.95,6.82,6.82,0,0,1,2.26,1.44,6.439,6.439,0,0,1-2.51-.95A6.73,6.73,0,0,1,190.78,298.76Z"
                    fill="#717272"
                />
                <path
                    id="Path_130"
                    data-name="Path 130"
                    d="M181.47,293.57a12.92,12.92,0,0,1,4.62,2.66,6.47,6.47,0,0,1-2.45-1.09C182.36,294.41,181.39,293.7,181.47,293.57Z"
                    fill="#717272"
                />
                <path
                    id="Path_131"
                    data-name="Path 131"
                    d="M172.47,287.87a6.649,6.649,0,0,1,2.38,1.22c1.23.81,2.16,1.56,2.08,1.69a6.731,6.731,0,0,1-2.39-1.22C173.31,288.75,172.38,288,172.47,287.87Z"
                    fill="#717272"
                />
                <path
                    id="Path_132"
                    data-name="Path 132"
                    d="M163.79,281.66a6.75,6.75,0,0,1,2.32,1.36c1.18.87,2.07,1.68,2,1.81a6.761,6.761,0,0,1-2.31-1.36C164.59,282.59,163.7,281.79,163.79,281.66Z"
                    fill="#717272"
                />
                <path
                    id="Path_133"
                    data-name="Path 133"
                    d="M155.48,275c.1-.12,1.1.55,2.23,1.48s2,1.79,1.88,1.91a6.65,6.65,0,0,1-2.23-1.48C156.22,276,155.38,275.1,155.48,275Z"
                    fill="#717272"
                />
                <path
                    id="Path_134"
                    data-name="Path 134"
                    d="M147.56,267.86c.1-.11,1.06.61,2.14,1.6s1.87,1.9,1.77,2a6.973,6.973,0,0,1-2.14-1.61C148.25,268.85,147.45,268,147.56,267.86Z"
                    fill="#717272"
                />
                <path
                    id="Path_135"
                    data-name="Path 135"
                    d="M140,260.29c.12-.1,1,.67,2.05,1.73s1.77,2,1.66,2.11-1-.67-2.05-1.73A6.954,6.954,0,0,1,140,260.29Z"
                    fill="#717272"
                />
                <path
                    id="Path_136"
                    data-name="Path 136"
                    d="M133,252.32c.11-.1,1,.73,1.95,1.84a6.72,6.72,0,0,1,1.53,2.2c-.12.1-1-.72-1.95-1.84S132.85,252.42,133,252.32Z"
                    fill="#717272"
                />
                <path
                    id="Path_137"
                    data-name="Path 137"
                    d="M126.35,244c.13-.09,1,.78,1.85,1.95a6.62,6.62,0,0,1,1.4,2.28c-.12.09-.94-.78-1.84-1.95a6.65,6.65,0,0,1-1.41-2.28Z"
                    fill="#717272"
                />
                <path
                    id="Path_138"
                    data-name="Path 138"
                    d="M120.23,235.24c.13-.09.9.83,1.73,2a6.53,6.53,0,0,1,1.27,2.36c-.13.09-.9-.82-1.73-2a6.62,6.62,0,0,1-1.27-2.36Z"
                    fill="#717272"
                />
                <path
                    id="Path_139"
                    data-name="Path 139"
                    d="M114.63,226.17c.13-.08.85.88,1.6,2.14a6.55,6.55,0,0,1,1.13,2.43c-.13.08-.85-.88-1.6-2.14a6.43,6.43,0,0,1-1.13-2.43Z"
                    fill="#717272"
                />
                <path
                    id="Path_140"
                    data-name="Path 140"
                    d="M109.55,216.8c.14-.07.8.93,1.48,2.23a6.59,6.59,0,0,1,1,2.49,12.93,12.93,0,0,1-2.47-4.72Z"
                    fill="#717272"
                />
                <path
                    id="Path_141"
                    data-name="Path 141"
                    d="M105,207.15a12.79,12.79,0,0,1,2.19,4.85,6.77,6.77,0,0,1-1.35-2.31,6.5,6.5,0,0,1-.84-2.54Z"
                    fill="#717272"
                />
                <path
                    id="Path_142"
                    data-name="Path 142"
                    d="M101,197.26a6.63,6.63,0,0,1,1.22,2.39,6.44,6.44,0,0,1,.7,2.58,12.8,12.8,0,0,1-1.92-5Z"
                    fill="#717272"
                />
                <path
                    id="Path_143"
                    data-name="Path 143"
                    d="M97.61,187.16a6.72,6.72,0,0,1,1.08,2.45,6.48,6.48,0,0,1,.56,2.63,6.7,6.7,0,0,1-1.08-2.45A6.5,6.5,0,0,1,97.61,187.16Z"
                    fill="#717272"
                />
                <path
                    id="Path_144"
                    data-name="Path 144"
                    d="M94.75,176.89a6.63,6.63,0,0,1,1,2.51,6.7,6.7,0,0,1,.41,2.65,6.64,6.64,0,0,1-1-2.51A6.72,6.72,0,0,1,94.75,176.89Z"
                    fill="#717272"
                />
                <path
                    id="Path_145"
                    data-name="Path 145"
                    d="M92.48,166.48a6.57,6.57,0,0,1,.8,2.55,6.74,6.74,0,0,1,.26,2.67,6.58,6.58,0,0,1-.8-2.56,6.48,6.48,0,0,1-.26-2.66Z"
                    fill="#717272"
                />
                <path
                    id="Path_146"
                    data-name="Path 146"
                    d="M90.79,156a6.84,6.84,0,0,1,.66,2.6,6.75,6.75,0,0,1,.11,2.68,6.63,6.63,0,0,1-.66-2.6,6.33,6.33,0,0,1-.11-2.68Z"
                    fill="#717272"
                />
                <path
                    id="Path_147"
                    data-name="Path 147"
                    d="M89.69,145.35a13,13,0,0,1,.47,5.31,13,13,0,0,1-.47-5.31Z"
                    fill="#717272"
                />
                <path
                    id="Path_148"
                    data-name="Path 148"
                    d="M89.2,134.7a6.52,6.52,0,0,1,.37,2.65,6.63,6.63,0,0,1-.2,2.68,6.82,6.82,0,0,1-.36-2.66,6.64,6.64,0,0,1,.19-2.67Z"
                    fill="#717272"
                />
                <path
                    id="Path_149"
                    data-name="Path 149"
                    d="M89.56,124.06a6.71,6.71,0,0,1,0,2.66,7.19,7.19,0,0,1-.35,2.65,6.18,6.18,0,0,1-.2-2.68,6.67,6.67,0,0,1,.55-2.63Z"
                    fill="#717272"
                />
                <path
                    id="Path_150"
                    data-name="Path 150"
                    d="M92.42,113.83a8.54,8.54,0,0,1-.74,2.56,8.09,8.09,0,0,1-1.05,2.45,9.36,9.36,0,0,1,1.79-5Z"
                    fill="#717272"
                />
                <path
                    id="Path_151"
                    data-name="Path 151"
                    d="M99.59,106.32c.06.15-1,.63-2.18,1.47s-2,1.67-2.13,1.56.57-1.12,1.81-2a4.15,4.15,0,0,1,2.5-1.03Z"
                    fill="#717272"
                />
                <path
                    id="Path_152"
                    data-name="Path 152"
                    d="M109.92,107.45a9.35,9.35,0,0,1-2.57-.72,10.53,10.53,0,0,1-2.5-.88,4.77,4.77,0,0,1,2.67.35A5.24,5.24,0,0,1,109.92,107.45Z"
                    fill="#717272"
                />
                <path
                    id="Path_153"
                    data-name="Path 153"
                    d="M173.79,288.38s-8.88,2-13.81,18.42-25,87.47-21.71,103.58,38,36.22,46.51,38.52l14-38.85-17.42-12,6.9-38.67Z"
                    fill="#717272"
                />
                <path
                    id="Path_154"
                    data-name="Path 154"
                    d="M343.63,484c-.52-1.84-9.76-78.9-9.76-78.9l6-123.92L288.31,263.1l-8.16-6.23-51.83.6-5.87,8.74-49.08,22.34L190.5,395.86l.33,71L190.36,484Z"
                    fill="#717272"
                />
                <path
                    id="Path_155"
                    data-name="Path 155"
                    d="M339.85,281.15S351.92,282.84,359,304s23.61,98,24.67,103.26,1.69,27.12-16.71,34.67c-17.68,7.25-36.86,0-36.86,0V403l7.75-8.46-3-13.72Z"
                    fill="#717272"
                />
                <path
                    id="Path_156"
                    data-name="Path 156"
                    d="M181.5,398.07c-.05.1-1.72-.75-4.58-1.65a37.484,37.484,0,0,0-17.93-1.05,37.939,37.939,0,0,0-5.09,1.32c-2.84,1-4.49,1.85-4.54,1.75a5.93,5.93,0,0,1,1.13-.67,14.207,14.207,0,0,1,1.39-.67c.55-.24,1.17-.54,1.89-.78a33.866,33.866,0,0,1,5.12-1.45,37.882,37.882,0,0,1,6.49-.69,38.7,38.7,0,0,1,6.5.53,34.486,34.486,0,0,1,5.16,1.34c.72.22,1.35.51,1.91.73a15.165,15.165,0,0,1,1.4.64,5.659,5.659,0,0,1,1.15.65Z"
                    fill="#333"
                />
                <path
                    id="Path_157"
                    data-name="Path 157"
                    d="M181.74,397.92c-.08.07-1.12-1.23-3.11-3a31,31,0,0,0-3.72-2.76,33.18,33.18,0,0,0-5.06-2.56,33.784,33.784,0,0,0-5.44-1.59,32.142,32.142,0,0,0-4.61-.53c-2.65-.09-4.28.15-4.3,0a4.5,4.5,0,0,1,1.14-.23,11,11,0,0,1,1.36-.14c.53,0,1.14-.09,1.81-.06a27.07,27.07,0,0,1,4.69.42,31,31,0,0,1,5.55,1.57,30.406,30.406,0,0,1,5.13,2.65,26.831,26.831,0,0,1,3.71,2.9c.51.44.91.9,1.28,1.28a11.453,11.453,0,0,1,.89,1A4.37,4.37,0,0,1,181.74,397.92Z"
                    fill="#333"
                />
                <path
                    id="Path_158"
                    data-name="Path 158"
                    d="M372.63,396.64a14.069,14.069,0,0,1-1.84-.77c-1.18-.52-2.88-1.27-5-2.06a49.083,49.083,0,0,0-7.72-2.2,35.744,35.744,0,0,0-4.69-.59,19,19,0,0,0-5,.3c-6.83,1.4-12.29,5.23-15.06,8.8a17.471,17.471,0,0,0-2.61,4.69,17.212,17.212,0,0,1-.59,1.9,1.519,1.519,0,0,1,.07-.51c.06-.33.15-.83.31-1.46a16.669,16.669,0,0,1,2.51-4.86c2.76-3.71,8.28-7.68,15.26-9.11a19.26,19.26,0,0,1,5.16-.29,34.85,34.85,0,0,1,4.76.63,46.65,46.65,0,0,1,7.76,2.33c2.15.85,3.83,1.65,5,2.23.58.29,1,.53,1.31.69S372.64,396.62,372.63,396.64Z"
                    fill="#333"
                />
                <path
                    id="Path_159"
                    data-name="Path 159"
                    d="M361.7,389.39c0,.1-1.45-.56-3.89-1.06a21.45,21.45,0,0,0-18.13,4.54c-1.91,1.59-2.85,2.83-2.93,2.77a3.789,3.789,0,0,1,.61-.91,19.091,19.091,0,0,1,2.07-2.16A20.45,20.45,0,0,1,357.9,388a17.569,17.569,0,0,1,2.83.93A3.76,3.76,0,0,1,361.7,389.39Z"
                    fill="#333"
                />
                <path
                    id="Path_160"
                    data-name="Path 160"
                    d="M272.82,310.69a3,3,0,0,1-.43-.27l-1.21-.84a52.848,52.848,0,0,0-4.75-2.83c-2.1-1.13-4.71-2.33-7.67-3.77a52.771,52.771,0,0,1-9.45-5.65l.37-.07c-2.78,4.67-5.85,9.82-9.08,15.26l-.33.55-.18-.62c-.21-.75-.44-1.55-.68-2.37a242.151,242.151,0,0,0-11.51-31.32c-1.75-3.9-3.25-7-4.3-9.17-.52-1-.92-1.86-1.22-2.47l-.31-.65a.68.68,0,0,1-.08-.23,1.121,1.121,0,0,1,.13.21l.36.62c.3.55.76,1.37,1.31,2.43,1.11,2.12,2.67,5.21,4.47,9.1A226.483,226.483,0,0,1,240,309.93c.23.81.46,1.62.68,2.37l-.51-.06L249.24,297l.15-.25.22.18a55.6,55.6,0,0,0,9.33,5.67c2.94,1.46,5.55,2.7,7.63,3.87a45.281,45.281,0,0,1,4.7,3c.52.38.91.7,1.17.9A2.129,2.129,0,0,1,272.82,310.69Z"
                    fill="#333"
                />
                <path
                    id="Path_161"
                    data-name="Path 161"
                    d="M291.6,264.71a4,4,0,0,1,.24.86c.15.61.34,1.44.58,2.49l2,9.18c.83,3.88,1.86,8.49,2.91,13.64a55.891,55.891,0,0,1,1.08,8.19,22.639,22.639,0,0,1-1.18,8.81c-.17.52-.42,1-.63,1.52l-.2.5-.29-.48a119.191,119.191,0,0,1-8.57-18.06l.42.06-9.68,12.93-2.75,3.6-.74.94a2.508,2.508,0,0,1-.27.31,1.471,1.471,0,0,1,.21-.35l.68-1,2.64-3.68c2.34-3.2,5.61-7.68,9.52-13.05l.26-.35.16.41a124.234,124.234,0,0,0,8.6,17.95h-.49c.2-.49.44-1,.61-1.47a22.38,22.38,0,0,0,1.16-8.6,57.3,57.3,0,0,0-1-8.12c-1.05-5.13-2-9.75-2.8-13.65s-1.4-7-1.85-9.22l-.48-2.51a8.26,8.26,0,0,1-.14-.85Z"
                    fill="#333"
                />
                <path
                    id="Path_162"
                    data-name="Path 162"
                    d="M366.23,330.65h-2.16l-6.18-.12c-5.38-.11-13.15-.25-22.76-.36-19.21-.26-45.76-.34-75.08-.41s-55.88-.22-75.1-.57c-9.6-.16-17.38-.36-22.75-.54l-6.18-.22-1.61-.07h1.61l6.19.11c5.37.11,13.14.26,22.75.37,19.21.25,45.76.34,75.09.4s55.87.22,75.09.57c9.61.16,17.38.37,22.75.54l6.19.22,1.6.08a4.493,4.493,0,0,1,.55,0Z"
                    fill="#fff"
                />
                <path
                    id="Path_163"
                    data-name="Path 163"
                    d="M184.89,400.94a10.521,10.521,0,0,1-1.43.92c-.47.28-1,.62-1.68,1.05s-1.39.89-2.17,1.47a60.091,60.091,0,0,0-5.33,4.24,65.335,65.335,0,0,0-5.79,6,63.571,63.571,0,0,0-4.86,6.77,56.684,56.684,0,0,0-3.23,6c-.44.87-.75,1.69-1.06,2.4s-.55,1.33-.73,1.84a9.34,9.34,0,0,1-.66,1.56,11.591,11.591,0,0,1,.45-1.63c.16-.53.37-1.16.65-1.88s.57-1.56,1-2.45a53.712,53.712,0,0,1,3.15-6.1,54.739,54.739,0,0,1,10.75-12.87,51.339,51.339,0,0,1,5.45-4.18c.8-.57,1.57-1,2.23-1.41s1.25-.73,1.74-1a9.7,9.7,0,0,1,1.52-.73Z"
                    fill="#fff"
                />
                <path
                    id="Path_164"
                    data-name="Path 164"
                    d="M337.63,444.42c0,.15-32.55-.09-72.7-.55s-72.7-.95-72.7-1.1,32.55.09,72.71.55S337.64,444.27,337.63,444.42Z"
                    fill="#fff"
                />
                <path
                    id="Path_165"
                    data-name="Path 165"
                    d="M380,426.5c-.06,0-.12-.87-.34-2.43a33.59,33.59,0,0,0-6.31-15.1,31.16,31.16,0,0,0-20.06-12.31A33.51,33.51,0,0,0,337,397.87c-1.49.51-2.3.85-2.32.8a2.421,2.421,0,0,1,.57-.29,17.722,17.722,0,0,1,1.68-.71,30.09,30.09,0,0,1,6.51-1.65,32.909,32.909,0,0,1,10,.13,32.16,32.16,0,0,1,25,21.34,29.888,29.888,0,0,1,1.48,6.55c.11.79.1,1.41.13,1.82A2.6,2.6,0,0,1,380,426.5Z"
                    fill="#fff"
                />
                <path
                    id="Path_166"
                    data-name="Path 166"
                    d="M241,278.73a38.169,38.169,0,0,1-3.82,5.3,37.6,37.6,0,0,1-4.26,5,76.819,76.819,0,0,1,8.08-10.3Z"
                    fill="#fff"
                />
                <path
                    id="Path_167"
                    data-name="Path 167"
                    d="M283.88,278.05a13.709,13.709,0,0,1,2.38-1.81l.13-.1.13.12c1,.87,2.22,2,3.55,3.25,1.56,1.48,3,2.84,3.95,3.84a9.42,9.42,0,0,1,1.53,1.71,9.668,9.668,0,0,1-1.8-1.42c-1.06-.93-2.5-2.25-4.06-3.72-1.33-1.25-2.54-2.42-3.46-3.34h.26a13.4,13.4,0,0,1-2.61,1.47Z"
                    fill="#fff"
                />
                <path
                    id="Path_168"
                    data-name="Path 168"
                    d="M180.94,324.4a2.7,2.7,0,0,1,.14.64c.08.49.18,1.1.3,1.87.25,1.69.59,4,1,6.86.81,5.87,1.91,13.86,3.13,22.69,2.26,17,3.85,29.07,4.24,32v.05h0v-.07l-.12-.48c-.09-.43-.2-1.05-.34-1.86-.27-1.62-.64-4-1.07-6.86-.86-5.8-2-13.82-3.19-22.68s-2.24-16.89-3-22.7c-.34-2.86-.63-5.2-.83-6.9-.08-.76-.15-1.38-.2-1.87a2.75,2.75,0,0,1-.06-.69Z"
                    fill="#333"
                />
                <path
                    id="Path_169"
                    data-name="Path 169"
                    d="M287.75,483.68a2.62,2.62,0,0,1-.06-.45c0-.32-.05-.75-.09-1.3-.08-1.17-.18-2.85-.32-5-.28-4.37-.67-10.66-1.16-18.41-1-15.55-2.53-37-4.59-60.7s-4.29-45.1-6-60.59c-.87-7.72-1.57-14-2.06-18.34-.23-2.14-.42-3.81-.55-5-.05-.55-.1-1-.13-1.3a1.91,1.91,0,0,1,0-.45,4,4,0,0,1,.08.44q.06.48.18,1.29c.16,1.17.38,2.84.66,5,.56,4.32,1.33,10.58,2.23,18.32,1.8,15.47,4.08,36.88,6.15,60.58s3.53,45.17,4.44,60.72c.45,7.78.78,14.08,1,18.43.1,2.16.17,3.84.22,5v1.3a2.652,2.652,0,0,1,0,.46Z"
                    fill="#333"
                />
                <path
                    id="Path_170"
                    data-name="Path 170"
                    d="M335.88,312.84c.15,0,.05,18.93-.24,42.26s-.63,42.26-.79,42.26,0-18.92.24-42.26S335.73,312.84,335.88,312.84Z"
                    fill="#333"
                />
                <path
                    id="Path_171"
                    data-name="Path 171"
                    d="M228.41,261.66l19.7,26.75,25.43,20.43,11.47-20-1.95-18.66-1.64-15.64s20.45-5.11,18.82-25.88c-.79-10-4.09-30.54-7.3-49.07a38.81,38.81,0,0,0-41.76-32l-2,.19c-21.46,3.22-30.72,23.25-26.9,44.62l6.13,69.27"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_172"
                    data-name="Path 172"
                    d="M281.44,254.56s-13,2.26-27.74-5.22c0,0,7.75,14.34,28.28,10.59Z"
                    fill="#ec996f"
                />
                <path
                    id="Path_173"
                    data-name="Path 173"
                    d="M287.44,196.59a3,3,0,0,1-2.59,3.25,2.83,2.83,0,0,1-3.29-2.39,3,3,0,0,1,2.58-3.25,2.84,2.84,0,0,1,3.3,2.39Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_174"
                    data-name="Path 174"
                    d="M289.62,189.05c-.34.42-2.73-1-5.92-.73s-5.38,2.1-5.76,1.74c-.18-.16.13-.89,1.08-1.72a8.23,8.23,0,0,1,4.57-1.88,7.85,7.85,0,0,1,4.75,1.07C289.39,188.2,289.78,188.86,289.62,189.05Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_175"
                    data-name="Path 175"
                    d="M256.93,199.45a3,3,0,0,1-2.59,3.24,2.84,2.84,0,0,1-3.29-2.39,3,3,0,0,1,2.58-3.25,2.86,2.86,0,0,1,3.3,2.4Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_176"
                    data-name="Path 176"
                    d="M257.77,191.05c-.28.45-2.82-.74-6-.1s-5.12,2.68-5.53,2.36c-.2-.13,0-.89.88-1.83a8.22,8.22,0,0,1,4.34-2.36,7.92,7.92,0,0,1,4.84.55C257.45,190.22,257.92,190.84,257.77,191.05Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_177"
                    data-name="Path 177"
                    d="M271.85,216.2c0-.18,1.92-.7,5.09-1.4.81-.16,1.56-.39,1.65-1a4.07,4.07,0,0,0-.77-2.36c-.94-1.9-1.93-3.9-3-6-4.14-8.52-7.22-15.56-6.88-15.72s4,6.61,8.13,15.13c1,2.1,2,4.1,2.88,6a4.78,4.78,0,0,1,.71,3.16,2.06,2.06,0,0,1-1.23,1.31,5.44,5.44,0,0,1-1.37.32C273.88,216.19,271.88,216.38,271.85,216.2Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_178"
                    data-name="Path 178"
                    d="M257,177.26c-.24.89-3.46.77-7.15,1.56s-6.63,2.09-7.2,1.35c-.26-.35.19-1.21,1.34-2.16a12.74,12.74,0,0,1,10.93-2.22C256.3,176.21,257.06,176.83,257,177.26Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_179"
                    data-name="Path 179"
                    d="M288.35,182.85c-.49.78-2.76.22-5.4.43s-4.83.93-5.42.22c-.26-.35,0-1.11.94-1.88a7.83,7.83,0,0,1,8.72-.52C288.19,181.76,288.57,182.47,288.35,182.85Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_180"
                    data-name="Path 180"
                    d="M225.37,207.59c-.37-.12-14.64-2.92-12.89,11.22s15.58,9.47,15.55,9.07S225.37,207.59,225.37,207.59Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_181"
                    data-name="Path 181"
                    d="M223.05,223.05c-.07,0-.22.2-.62.45a2.47,2.47,0,0,1-1.83.26c-1.56-.36-3.11-2.58-3.5-5.12a8.27,8.27,0,0,1,.26-3.61,2.85,2.85,0,0,1,1.62-2.12,1.26,1.26,0,0,1,1.53.5c.24.37.19.66.27.68s.27-.28.08-.85a1.58,1.58,0,0,0-.66-.81,1.86,1.86,0,0,0-1.41-.2,3.49,3.49,0,0,0-2.3,2.51,8.47,8.47,0,0,0-.37,4c.44,2.84,2.23,5.32,4.35,5.66a2.62,2.62,0,0,0,2.2-.65C223.07,223.4,223.1,223.07,223.05,223.05Z"
                    fill="#717272"
                />
                <path
                    id="Path_182"
                    data-name="Path 182"
                    d="M293,155.21c-.87-2.69-3.14-5.13-6-5.29a6.48,6.48,0,0,0-10.77-6.6c-.22-4.34-5.85-7.34-9.58-5.1a5.61,5.61,0,0,0-10.74-2.1c-3.43-4.82-11.79-4.74-15.13.14a12.36,12.36,0,0,0-14.35,8,11.75,11.75,0,0,0-9.57,9,8.59,8.59,0,0,0-5.12,14c-3.43,2.05-3.66,7.8-.4,10.12a6.25,6.25,0,0,0,1.19,11.23c-2.06.45-2.65,3.28-1.84,5.24s2.46,3.43,3.46,5.29c.82,1.53,1.18,3.27,1.91,4.85a11.29,11.29,0,0,0,7.29,6.08l-.33.46c-.21,1.85,2.44,2.87,4.08,2s2.46-2.73,3.3-4.39a19.471,19.471,0,0,0,2.47-5.87c.33-2.11-.48-4.59-2.46-5.4,2.38-1,3.73-3.67,4-6.25a22,22,0,0,0-1.14-7.65l-3-11.06a14.21,14.21,0,0,0,11.51-9.15c3.93,2.51,10,.44,11.51-3.95a10.62,10.62,0,0,0,13.45,5.37c-.3,3,5.22,5.23,8.17,5.74s6.39-1.85,6.39-1.85,5.23,2.49,7.85,1.16,5.86-5.06,3.85-7.7A13.28,13.28,0,0,0,293,155.21Z"
                    fill="#717272"
                />
                <path
                    id="Path_183"
                    data-name="Path 183"
                    d="M210.69,177.31c.13-.06.31,1,1.57,1.7a2.72,2.72,0,0,0,2.36.21,2.89,2.89,0,0,0,1.79-2.27l.09-.87.71.52a3.69,3.69,0,0,0,5.81-3.7l-.17-.83.8.26a3.74,3.74,0,0,0,4.47-2,10.1,10.1,0,0,0,.53-2.15c.07,0,.51.86,0,2.37a4.18,4.18,0,0,1-1.74,2.18,4.52,4.52,0,0,1-3.57.51l.63-.57a4.74,4.74,0,0,1-2.33,5.11,4.8,4.8,0,0,1-5.06-.4l.8-.35a3.7,3.7,0,0,1-2.5,3,3.32,3.32,0,0,1-3-.49C210.53,178.46,210.61,177.27,210.69,177.31Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_184"
                    data-name="Path 184"
                    d="M209.78,191.09a8.8,8.8,0,0,0,1.57.46,3.42,3.42,0,0,0,3.43-1.84l.23-.52.43.39a3.82,3.82,0,0,0,3.71.68,3.7,3.7,0,0,0,2.35-3.55v-.94l.83.44a2.11,2.11,0,0,0,.68.24,2.6,2.6,0,0,0,2.78-1.21,2.75,2.75,0,0,0-.14-2.84l-.61-.83,1,.07a4.47,4.47,0,0,0,4.6-3.41,10.43,10.43,0,0,0,.1-2.5,3.318,3.318,0,0,1,.46,2.62,4.91,4.91,0,0,1-1.43,2.78A5.24,5.24,0,0,1,226,182.6l.41-.77a3.59,3.59,0,0,1-3.62,5.68,3.47,3.47,0,0,1-1-.36l.79-.49a4.56,4.56,0,0,1-7.7,3.53l.67-.14a3.6,3.6,0,0,1-2.16,1.84,3.8,3.8,0,0,1-2.11.12C210.12,191.73,209.73,191.11,209.78,191.09Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_185"
                    data-name="Path 185"
                    d="M264.83,138a5.54,5.54,0,0,0-1.68-.77,2.94,2.94,0,0,0-2.06.3,3.07,3.07,0,0,0-1.54,2.21l-.12.82-.49-.68a5.19,5.19,0,0,0-4.59-2.06,5,5,0,0,0-4.36,4l-.19,1-.66-.72a6.36,6.36,0,0,0-5.12-1.91,6.19,6.19,0,0,0-5.46,5.65v.58l-.58-.09a6.07,6.07,0,0,0-6.47,3.77,6.19,6.19,0,0,0,1.6,6.54l.6.53-.77.21a6.73,6.73,0,0,0-4,3.1,6.59,6.59,0,0,0-.85,3.87,10.059,10.059,0,0,0,1.06,3.37,3,3,0,0,1-.62-.74,6.559,6.559,0,0,1-.92-2.58,6.91,6.91,0,0,1,.72-4.26,7.36,7.36,0,0,1,4.39-3.59l-.17.74a6.9,6.9,0,0,1,5.61-12l-.62.5a7.23,7.23,0,0,1,6.44-6.63,7.31,7.31,0,0,1,5.94,2.3l-.85.23a5.79,5.79,0,0,1,10.47-2.12l-.61.14a3.63,3.63,0,0,1,2-2.57,3.32,3.32,0,0,1,2.38-.19,3.37,3.37,0,0,1,1.3.72A.624.624,0,0,1,264.83,138Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_186"
                    data-name="Path 186"
                    d="M299,217.39a4.46,4.46,0,0,0-6.43,2.57,5.54,5.54,0,0,0-9.71,2.31c-1.12-3-5.93-3.47-7.65-.82a3.56,3.56,0,0,0-4-1.3,3.51,3.51,0,0,0-5.92-2.76,5.72,5.72,0,0,0-8.54-.88,3.17,3.17,0,0,0-6.1.6,5.17,5.17,0,0,0-6-1.18,3.44,3.44,0,0,0-4.46-2.88c.38-1.79-2.24-2.42-3.64-3.59-.62-.53-1.05-1.28-1.71-1.75s-1.78-.51-2.15.22a2.94,2.94,0,0,0-5.64-1.58,8.919,8.919,0,0,0-.33,2.53c-.22,2.75-1.55,6.08.54,7.88.37.31.84.56,1,1,.3.77-.42,1.57-.43,2.4s.92,1.65,1.37,2.5c.66,1.27.22,2.8.21,4.23s.91,3.19,2.32,3a5,5,0,0,0,1.95,6.1,4.89,4.89,0,0,0,3.26,6.23,2.51,2.51,0,0,0,0,3.31,7.25,7.25,0,0,0,3,1.92,2.08,2.08,0,0,0-.32,2.95,4.72,4.72,0,0,0,2.89,1.53,2.06,2.06,0,0,1,1.28.58c.56.71-.06,1.75.13,2.63.3,1.34,2.23,1.61,2.88,2.82s0,2.68,1,3.46c.61.51,1.52.35,2.28.57,1.36.39,2,1.85,3,2.92,1.73,2,4.49,2.8,7.11,3.29,1.34.25,2.68.46,4,.62,2.69.33,5.39.49,8.1.65,1.34.07,3,0,3.61-1.19a4.65,4.65,0,0,0,7.32-1.33c2.44.49,4.87-.67,7.09-1.81l2.3-1.17c2.28-1.17,4.81-2.64,5.35-5.15a5.17,5.17,0,0,0,3.27-7.29c1.08.24,2-.91,2.16-2a10,10,0,0,0-.63-3.26c-1.09-4.4,1-9.09.1-13.53-.62-3.11-2.68-6.1-2-9.19a5.611,5.611,0,0,0,.32-1.92c-.08-.65-.72-1.29-1.34-1.06a2.9,2.9,0,0,0-3.16-3.66"
                    fill="#717272"
                />
                <path
                    id="Path_187"
                    data-name="Path 187"
                    d="M262.67,219.26c.51-.08.83,3.38,4,5.57s6.83,1.47,6.9,1.95c.07.21-.76.75-2.31.93a8.71,8.71,0,0,1-5.75-1.43,7.55,7.55,0,0,1-3.15-4.69C262.12,220.15,262.43,219.26,262.67,219.26Z"
                    fill="#fff"
                />
                <path
                    id="Path_188"
                    data-name="Path 188"
                    d="M243.91,244.93c.17-.07-1.48-3.11-1.79-7.26s.75-7.42.56-7.46a6.36,6.36,0,0,0-.74,2.11,17.29,17.29,0,0,0-.38,5.4,17.71,17.71,0,0,0,1.26,5.25,6.14,6.14,0,0,0,1.09,1.96Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_189"
                    data-name="Path 189"
                    d="M240.33,240.12c.07-.07-.47-.53-.89-1.53a10.28,10.28,0,0,1-.6-4.17,54.793,54.793,0,0,1,.65-6.08,13.92,13.92,0,0,0-1.21,6.07,9,9,0,0,0,.8,4.36C239.64,239.8,240.31,240.17,240.33,240.12Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_190"
                    data-name="Path 190"
                    d="M236.66,237.46c.17-.08-1.54-2.55-1.88-6.1a20.661,20.661,0,0,1,.59-6.35,4.44,4.44,0,0,0-.77,1.77,12.6,12.6,0,0,0,1,9.1,4.6,4.6,0,0,0,1.06,1.58Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_191"
                    data-name="Path 191"
                    d="M295.8,255.12a3.63,3.63,0,0,0,1.9-1.38,11.39,11.39,0,0,0,2.16-5.24,17.6,17.6,0,0,0,.13-5.65,6.29,6.29,0,0,0-.6-2.26,28.092,28.092,0,0,1-.08,7.81,12.69,12.69,0,0,1-1.92,5.09,14.34,14.34,0,0,1-1.59,1.63Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_192"
                    data-name="Path 192"
                    d="M292.72,254.55a4.31,4.31,0,0,0,1.53-1.22,11.15,11.15,0,0,0,2.85-8.8,4.409,4.409,0,0,0-.53-1.89,15.786,15.786,0,0,0,.13,1.92,12.88,12.88,0,0,1-.6,4.51,12.67,12.67,0,0,1-2.15,4,15.3,15.3,0,0,0-1.23,1.48Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_193"
                    data-name="Path 193"
                    d="M278.15,227.29a3.46,3.46,0,0,0,.11-2.71c-.4-1.5-1.35-2.4-1.45-2.29s.55,1.07.9,2.44S278,227.26,278.15,227.29Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_194"
                    data-name="Path 194"
                    d="M274.5,226.65c.1.11.94-.74,1.07-2.14s-.52-2.4-.64-2.31.21,1,.08,2.25S274.37,226.55,274.5,226.65Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_195"
                    data-name="Path 195"
                    d="M270.82,225.77c.11.1.88-.7,1.14-2s-.1-2.32-.24-2.27-.06,1-.31,2.15S270.69,225.67,270.82,225.77Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_196"
                    data-name="Path 196"
                    d="M268.06,223c.13.07.53-.46.75-1.22s.14-1.43,0-1.44-.33.57-.54,1.28S267.91,222.91,268.06,223Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_197"
                    data-name="Path 197"
                    d="M265.74,222c.14.06.58-.66,1.34-1.33s1.52-1,1.47-1.2-1,0-1.84.78S265.59,221.9,265.74,222Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_198"
                    data-name="Path 198"
                    d="M262.24,219.59c.12.12,1-.72,2.41-1.16s2.6-.34,2.63-.51a3.44,3.44,0,0,0-2.8,0C262.93,218.4,262.12,219.51,262.24,219.59Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_199"
                    data-name="Path 199"
                    d="M277.86,259.24a6.67,6.67,0,0,0,1.38-2,15.38,15.38,0,0,0,1.09-11.47,6.82,6.82,0,0,0-1-2.22c-.09,0,.27.89.61,2.32a17.54,17.54,0,0,1-1.06,11.19A23.4,23.4,0,0,0,277.86,259.24Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_200"
                    data-name="Path 200"
                    d="M274.19,259.24a12.08,12.08,0,0,0,2.51-11.39c-.18,0,.39,2.7-.34,5.9a25.929,25.929,0,0,1-2.17,5.49Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_201"
                    data-name="Path 201"
                    d="M267.7,258.38a3.494,3.494,0,0,0,1.42-.8,9.87,9.87,0,0,0,3.68-6.83,3.33,3.33,0,0,0-.12-1.63,13,13,0,0,1-5,9.26Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_202"
                    data-name="Path 202"
                    d="M272.63,399.31s-28.63-2.17-44.3,1.74l-.72,5.94s-12.1-2.73-12.28,7.95,0,23.33,14.07,26v6.6s7,4.55,22,3.66,22.69-3,22.69-3ZM229.5,432.87a3.84,3.84,0,0,1-.7,2.38,2.58,2.58,0,0,1-2.62.61,6.09,6.09,0,0,1-2.36-1.53,19.75,19.75,0,0,1-6.08-15.22,10.62,10.62,0,0,1,1.81-5.82,5.65,5.65,0,0,1,5.38-2.35c2,.41,4.07,1.29,4.13,4.31l.14,1.11a103.42,103.42,0,0,1,.3,16.51Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_203"
                    data-name="Path 203"
                    d="M190.32,413.7s-4.72,3.2-6,8.54-3.2,18.52.89,21.37,25.46,15.13,29.92,15.67,17.8-.36,19.4-1.25,2.59-3.77,2.59-3.77c1.37-.49,4.46-3.35,4-3.71s-3.38-8.72-7.48-10.68-15.13-7.66-16-9.61,12-.74,12-.74a111.777,111.777,0,0,0-.32-11.19s-13.69-2.85-14-3.39,3.92-6.94,5.52-7.83,6.76-.12,6.76-.12l.72-5.94a46.443,46.443,0,0,0-5.15-2.49,5.64,5.64,0,0,0-4.94.19Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_204"
                    data-name="Path 204"
                    d="M239.64,447.47a5.894,5.894,0,0,1-1.27,0l-3.44-.3-5.09-.51-3-.32a15.889,15.889,0,0,1-3.23-.68c-.54-.16-1.06-.32-1.59-.52l-1.48-.61-2.79-1.16-4.72-2L209.87,440a5.189,5.189,0,0,1-1.13-.58,5.308,5.308,0,0,1,1.21.38l3.23,1.22,4.76,1.88,2.8,1.13,1.48.6c.49.19,1,.35,1.55.51a16.356,16.356,0,0,0,3.11.67l3,.35,5.09.63,3.42.47a5.232,5.232,0,0,1,1.25.21Z"
                    fill="#717272"
                />
                <path
                    id="Path_205"
                    data-name="Path 205"
                    d="M237.15,454.26a5.23,5.23,0,0,1-1.25.25c-.8.13-2,.29-3.43.43a38.24,38.24,0,0,1-11.43-.41,32.34,32.34,0,0,1-10.69-4,20.889,20.889,0,0,1-2.77-2.1,4.69,4.69,0,0,1-.88-.92c.06-.08,1.36,1.2,3.86,2.68A34.64,34.64,0,0,0,221.15,454a42.541,42.541,0,0,0,11.29.57l3.44-.25a5.592,5.592,0,0,1,1.27-.06Z"
                    fill="#717272"
                />
                <path
                    id="Path_206"
                    data-name="Path 206"
                    d="M202.27,439.62c0,.09-.31.18-.74.45a3.21,3.21,0,0,0-1.24,1.42,3.17,3.17,0,0,0-.15,1.89c.11.49.27.78.2.83s-.35-.18-.57-.71a2.89,2.89,0,0,1,1.59-3.78C201.9,439.51,202.26,439.56,202.27,439.62Z"
                    fill="#717272"
                />
                <path
                    id="Path_207"
                    data-name="Path 207"
                    d="M205.16,430.23c0,.08-.36.25-.87.62a4.66,4.66,0,0,0-1.95,4.25c0,.64.17,1,.09,1.06s-.32-.32-.48-1a4.24,4.24,0,0,1,2.13-4.64C204.7,430.2,205.14,430.17,205.16,430.23Z"
                    fill="#717272"
                />
                <path
                    id="Path_208"
                    data-name="Path 208"
                    d="M209.7,416.56c0,.09-.42.23-1,.6a5.81,5.81,0,0,0-2,1.94,5.56,5.56,0,0,0-.77,2.65,7.776,7.776,0,0,1,0,1.2c-.05.02-.29-.41-.36-1.19a5.09,5.09,0,0,1,.69-2.95,5,5,0,0,1,2.27-2C209.2,416.51,209.69,416.5,209.7,416.56Z"
                    fill="#717272"
                />
                <path
                    id="Path_209"
                    data-name="Path 209"
                    d="M215,417.51a20.18,20.18,0,0,0-1.49-4c-1.15-2.07-2.33-3.65-2.19-3.75a11.149,11.149,0,0,1,2.68,3.48,9.13,9.13,0,0,1,1,3C215.18,417,215.1,417.51,215,417.51Z"
                    fill="#717272"
                />
                <path
                    id="Path_210"
                    data-name="Path 210"
                    d="M272.68,419.09a3.948,3.948,0,0,0-.38-.55,3,3,0,0,0-1.6-1,4,4,0,0,0-2.87.4,7,7,0,0,0-2.58,2.94c-.71,1.31-1.21,2.89-2.08,4.47a7.761,7.761,0,0,1-1.74,2.21,7.07,7.07,0,0,1-8.79.35,7.17,7.17,0,0,1-2.85-6.06c.05-1.18.27-2.3.35-3.4a4.9,4.9,0,0,0-.54-3,3.82,3.82,0,0,0-2.4-1.64,9.55,9.55,0,0,0-3-.25,28.739,28.739,0,0,1-2.93,0,6.451,6.451,0,0,1-2.73-.74,7.16,7.16,0,0,1-3.18-3.82,8.39,8.39,0,0,1-.36-4,11.42,11.42,0,0,1,.82-3,11.539,11.539,0,0,1,.9-1.74,2.879,2.879,0,0,1,.39-.55,17.9,17.9,0,0,0-1.09,2.37,11.731,11.731,0,0,0-.71,2.94,8.19,8.19,0,0,0,.47,3.91,6.84,6.84,0,0,0,3,3.55c1.51.85,3.44.71,5.42.6a10.689,10.689,0,0,1,3.11.25,4.4,4.4,0,0,1,2.73,1.87,5.41,5.41,0,0,1,.63,3.36c-.08,1.14-.3,2.26-.35,3.38a6.66,6.66,0,0,0,2.63,5.61,6.38,6.38,0,0,0,5.69,1,6.76,6.76,0,0,0,4.11-3.36c.85-1.52,1.38-3.1,2.13-4.44a7.32,7.32,0,0,1,2.78-3,4.09,4.09,0,0,1,3.08-.33,3,3,0,0,1,1.63,1.08,1.83,1.83,0,0,1,.31.59Z"
                    fill="#717272"
                />
                <path
                    id="Path_211"
                    data-name="Path 211"
                    d="M260.33,450.27c-.05,0,.23-.56.4-1.62a6.77,6.77,0,0,0-.78-4.31,6.54,6.54,0,0,0-5.38-3.25,26.337,26.337,0,0,0-3.93.47,5.33,5.33,0,0,1-4.28-1.05,3.84,3.84,0,0,1-1.06-2.05c-.15-.73-.2-1.45-.29-2.12a3.75,3.75,0,0,0-1.87-3.09,5.42,5.42,0,0,0-3.36-.57,7,7,0,0,0-2.83,1.1,8,8,0,0,0-2.86,3.38c-.44,1-.52,1.58-.57,1.57a1.24,1.24,0,0,1,0-.44,7.1,7.1,0,0,1,.34-1.21,7.88,7.88,0,0,1,2.84-3.62,7.18,7.18,0,0,1,3-1.24,5.9,5.9,0,0,1,3.68.58,3.81,3.81,0,0,1,1.5,1.43,5.22,5.22,0,0,1,.66,2c.2,1.37.18,2.91,1.19,3.85a4.87,4.87,0,0,0,3.84.91,26.3,26.3,0,0,1,4-.44,6.88,6.88,0,0,1,5.7,3.57,6.71,6.71,0,0,1,.65,4.54,5.411,5.411,0,0,1-.39,1.2C260.43,450.15,260.35,450.28,260.33,450.27Z"
                    fill="#717272"
                />
                <path
                    id="Path_212"
                    data-name="Path 212"
                    d="M270.73,448.54a1.4,1.4,0,0,1-.87.23,3.19,3.19,0,0,1-2.22-1.07,5.8,5.8,0,0,1-1.26-3.41,23.218,23.218,0,0,1,0-4.41,11.41,11.41,0,0,1,1.26-4.26,8.23,8.23,0,0,1,2.41-2.72,6,6,0,0,1,2.24-1,2,2,0,0,1,.9-.05,8.4,8.4,0,0,0-2.9,1.35,8.21,8.21,0,0,0-2.2,2.64,11.849,11.849,0,0,0-1.16,4.08,25.939,25.939,0,0,0-.05,4.3,5.54,5.54,0,0,0,1.05,3.2,3.08,3.08,0,0,0,1.93,1.11,7.429,7.429,0,0,0,.87.01Z"
                    fill="#717272"
                />
                <path
                    id="Path_213"
                    data-name="Path 213"
                    d="M271.53,400a2.12,2.12,0,0,1,0,.92,7.23,7.23,0,0,1-.81,2.4,7.446,7.446,0,0,1-13.52-.94,6.88,6.88,0,0,1-.47-2.48,2.05,2.05,0,0,1,.12-.92,10.68,10.68,0,0,0,.71,3.25,7.43,7.43,0,0,0,2.14,2.83,7.25,7.25,0,0,0,8.17.57,7.5,7.5,0,0,0,2.51-2.51A11.21,11.21,0,0,0,271.53,400Z"
                    fill="#717272"
                />
                <path
                    id="Path_214"
                    data-name="Path 214"
                    d="M336.54,407.91l.54,4.16-4,4.9-12.22,17.4-30.17-3.88,6.14-13,4-7.08a5.8,5.8,0,0,1,5.08-2.92"
                    fill="#595a5a"
                />
                <path
                    id="Path_215"
                    data-name="Path 215"
                    d="M328.79,407.75s7.57-6.73,12.64-5.1,19.57,0,19.2,6.16-2.71,9.42-7.24,8.7a19.31,19.31,0,0,1-6.56-2s1.59.36,0,5.79-7.39,15.66-9.57,18.07-3.08,2.67-4.17,2.54-5.43,4-7.06,4.21-.91,0-.91,0a10.49,10.49,0,0,1-12.32,1.34c-7.06-3.87-13.22-5.5-13.77-6.41s-8.51-8.61-10-10.83-5.43-11.82-5.25-12.72,4.34-4.24,7.61-.95c0,0,1.81-1.59,5.43.95s14.31,5.91,14.31,5.91-1.63-2-1.45-3.66,1.63-4.61,4.35-4.24,19.39,2,19.39,2l3.62-5.44-.54-4.16Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_216"
                    data-name="Path 216"
                    d="M339.63,429.33a4.868,4.868,0,0,1-1.15.27,26.658,26.658,0,0,1-3.19.4,37.76,37.76,0,0,1-20.48-4.44,25.15,25.15,0,0,1-2.73-1.68,5.25,5.25,0,0,1-.93-.72c.05-.09,1.44.84,3.84,2a42.38,42.38,0,0,0,9.87,3.48,43.059,43.059,0,0,0,10.41.92C338,429.5,339.61,429.23,339.63,429.33Z"
                    fill="#717272"
                />
                <path
                    id="Path_217"
                    data-name="Path 217"
                    d="M340,417a11.63,11.63,0,0,1-8.13.37c0-.16,1.84.11,4.07,0S339.9,416.82,340,417Z"
                    fill="#717272"
                />
                <path
                    id="Path_218"
                    data-name="Path 218"
                    d="M348.14,416.39c-.07.15-2.51-.89-5.66-1.75s-5.77-1.25-5.75-1.42a24.331,24.331,0,0,1,11.41,3.17Z"
                    fill="#717272"
                />
                <path
                    id="Path_219"
                    data-name="Path 219"
                    d="M346.55,404.76c.16.05-.46,1.93-.49,4.33a10.071,10.071,0,0,0,.3,3c.25.72.74.89.71,1s-.15,0-.37-.07a1.61,1.61,0,0,1-.69-.74,7.41,7.41,0,0,1-.5-3.17A8,8,0,0,1,346.55,404.76Z"
                    fill="#717272"
                />
                <path
                    id="Path_220"
                    data-name="Path 220"
                    d="M329.92,439.83a2.209,2.209,0,0,1-.54,0l-1.53-.06c-1.33-.06-3.26-.17-5.63-.44A41.119,41.119,0,0,1,314,437.6a26.82,26.82,0,0,1-4.57-2c-1.52-.83-3-1.8-4.54-2.77-6.89-4.4-13-8.36-17-11l-.09-.06v-.11a6,6,0,0,1,2.19-3.93,5.409,5.409,0,0,1,1-.64c.25-.11.39-.16.39-.14a11.358,11.358,0,0,0-1.3.93,6,6,0,0,0-2,3.82l-.08-.17c4,2.5,10.2,6.39,17.08,10.79,1.54,1,3,1.94,4.51,2.76a28,28,0,0,0,4.47,2,44.173,44.173,0,0,0,8.11,1.82c2.35.32,4.27.48,5.6.62l1.52.16a1.9,1.9,0,0,1,.63.15Z"
                    fill="#717272"
                />
                <path
                    id="Path_221"
                    data-name="Path 221"
                    d="M324.08,445.71a8.09,8.09,0,0,1-1.62-.18c-1-.16-2.53-.42-4.36-.81a82.649,82.649,0,0,1-14-4.33,28.892,28.892,0,0,1-6.95-4.15,41.93,41.93,0,0,1-4.73-4.62c-1.24-1.4-2.19-2.59-2.83-3.41a9.26,9.26,0,0,1-1-1.32,7.9,7.9,0,0,1,1.12,1.18c.7.78,1.69,1.92,3,3.29a46.153,46.153,0,0,0,4.76,4.48,29.48,29.48,0,0,0,6.85,4,96,96,0,0,0,13.87,4.45c1.82.45,3.3.77,4.32,1a10.889,10.889,0,0,1,1.57.42Z"
                    fill="#717272"
                />
                <path
                    id="Path_222"
                    data-name="Path 222"
                    d="M336.84,412.47a7.721,7.721,0,0,1-1.57,0l-4.28-.07c-3.61-.08-8.6-.24-14.11-.44a61.427,61.427,0,0,0-7.74.11l-1.74.1a2.61,2.61,0,0,0-1.47.35,7.83,7.83,0,0,0-2.1,1.93,22.777,22.777,0,0,0-2.31,3.56,13.546,13.546,0,0,1-.75,1.37,6.8,6.8,0,0,1,.55-1.47,20.249,20.249,0,0,1,2.2-3.7,8.249,8.249,0,0,1,2.18-2.09,3,3,0,0,1,.8-.34,4.646,4.646,0,0,1,.87-.1l1.74-.12a56.6,56.6,0,0,1,7.79-.16c5.51.21,10.49.43,14.1.61l4.27.25a10.223,10.223,0,0,1,1.57.21Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_223"
                    data-name="Path 223"
                    d="M179.06,313.36a78.486,78.486,0,0,1-3.06-8.79,77.2,77.2,0,0,1-2.52-8.95,78.854,78.854,0,0,1,3.05,8.79A76.17,76.17,0,0,1,179.06,313.36Z"
                    fill="#263238"
                />
                <path
                    id="Path_224"
                    data-name="Path 224"
                    d="M339.4,287.07a13.449,13.449,0,0,1-.27,2.61c-.24,1.81-.53,3.92-.84,6.26s-.52,4.47-.73,6.28a12.52,12.52,0,0,1-.38,2.6,11.66,11.66,0,0,1,0-2.63c.08-1.62.26-3.86.57-6.31s.68-4.67,1-6.27a11.8,11.8,0,0,1,.65-2.54Z"
                    fill="#263238"
                />
                <path
                    id="Path_225"
                    data-name="Path 225"
                    d="M163.26,346.87v31.82H302.23l19.44,22.55V378.69h43.41V346.87Z"
                    fill="#fafbfb"
                />
                <path
                    id="Path_226"
                    data-name="Path 226"
                    d="M183.46,359.85,181.24,366h-1.71l-1.38-3.81L176.72,366H175l-2.21-6.13h1.68l1.45,4.15,1.5-4.15h1.51L180.4,364l1.49-4.15Z"
                    fill="#717272"
                />
                <path
                    id="Path_227"
                    data-name="Path 227"
                    d="M194,359.85,191.78,366h-1.71l-1.38-3.81L187.26,366h-1.71l-2.21-6.13H185l1.44,4.15,1.51-4.15h1.5l1.46,4.15,1.5-4.15Z"
                    fill="#717272"
                />
                <path
                    id="Path_228"
                    data-name="Path 228"
                    d="M204.54,359.85,202.32,366h-1.71l-1.38-3.81L197.8,366h-1.71l-2.21-6.13h1.67L197,364l1.51-4.15H200l1.46,4.15,1.5-4.15Z"
                    fill="#717272"
                />
                <path
                    id="Path_229"
                    data-name="Path 229"
                    d="M204.58,365a1.11,1.11,0,1,1,.52,1.049,1.11,1.11,0,0,1-.52-1.049Z"
                    fill="#717272"
                />
                <path
                    id="Path_230"
                    data-name="Path 230"
                    d="M214.17,357.52V366h-1.7v-.7a2.39,2.39,0,0,1-1.92.79,3.16,3.16,0,0,1,0-6.31,2.38,2.38,0,0,1,1.84.74v-3Zm-1.75,5.4a1.57,1.57,0,1,0-1.56,1.69,1.55,1.55,0,0,0,1.56-1.69Z"
                    fill="#717272"
                />
                <path
                    id="Path_231"
                    data-name="Path 231"
                    d="M215.35,362.92a3.38,3.38,0,1,1,3.38,3.15,3.16,3.16,0,0,1-3.38-3.15Zm4.94,0a1.57,1.57,0,1,0-1.56,1.69,1.54,1.54,0,0,0,1.56-1.69Z"
                    fill="#717272"
                />
                <path
                    id="Path_232"
                    data-name="Path 232"
                    d="M233.64,362.47V366h-1.77v-3.24c0-1-.45-1.44-1.17-1.44s-1.35.51-1.35,1.6V366h-1.78v-3.24c0-1-.42-1.44-1.17-1.44s-1.34.51-1.34,1.6V366h-1.78v-6.13H225v.7a2.5,2.5,0,0,1,1.93-.79,2.28,2.28,0,0,1,2,1,2.75,2.75,0,0,1,2.22-1C232.6,359.76,233.64,360.6,233.64,362.47Z"
                    fill="#717272"
                />
                <path
                    id="Path_233"
                    data-name="Path 233"
                    d="M240.67,362.48V366H239v-.76a2,2,0,0,1-1.87.85c-1.44,0-2.3-.79-2.3-1.86s.77-1.83,2.64-1.83h1.41c0-.76-.45-1.21-1.41-1.21a3,3,0,0,0-1.77.57l-.64-1.24a4.72,4.72,0,0,1,2.65-.74C239.59,359.76,240.67,360.62,240.67,362.48ZM238.89,364v-.62h-1.22c-.83,0-1.09.3-1.09.72s.37.74,1,.74a1.31,1.31,0,0,0,1.31-.84Z"
                    fill="#717272"
                />
                <path
                    id="Path_234"
                    data-name="Path 234"
                    d="M242.06,358a1.111,1.111,0,0,1,2.22,0,1.12,1.12,0,0,1-2.22,0Zm.22,1.85h1.78V366h-1.78Z"
                    fill="#717272"
                />
                <path
                    id="Path_235"
                    data-name="Path 235"
                    d="M252,362.47V366h-1.8v-3.24c0-1-.45-1.44-1.24-1.44a1.456,1.456,0,0,0-1.47,1.65v3h-1.78v-6.13h1.7v.72a2.67,2.67,0,0,1,2-.81,2.4,2.4,0,0,1,2.59,2.72Z"
                    fill="#717272"
                />
                <path
                    id="Path_236"
                    data-name="Path 236"
                    d="M259.87,362.47V366h-1.78v-3.24c0-1-.46-1.44-1.25-1.44a1.456,1.456,0,0,0-1.47,1.65v3h-1.78v-6.13h1.7v.72a2.67,2.67,0,0,1,2-.81,2.41,2.41,0,0,1,2.58,2.72Z"
                    fill="#717272"
                />
                <path
                    id="Path_237"
                    data-name="Path 237"
                    d="M266.9,362.48V366h-1.66v-.76a2,2,0,0,1-1.87.85c-1.44,0-2.29-.79-2.29-1.86s.76-1.83,2.63-1.83h1.41c0-.76-.45-1.21-1.41-1.21a3,3,0,0,0-1.77.57l-.64-1.24a4.74,4.74,0,0,1,2.65-.74C265.82,359.76,266.9,360.62,266.9,362.48ZM265.12,364v-.62H263.9c-.83,0-1.09.3-1.09.72s.37.74,1,.74A1.31,1.31,0,0,0,265.12,364Z"
                    fill="#717272"
                />
                <path
                    id="Path_238"
                    data-name="Path 238"
                    d="M278.88,362.47V366H277.1v-3.24c0-1-.45-1.44-1.17-1.44s-1.35.51-1.35,1.6V366H272.8v-3.24c0-1-.42-1.44-1.16-1.44s-1.35.51-1.35,1.6V366h-1.78v-6.13h1.7v.7a2.5,2.5,0,0,1,1.93-.79,2.31,2.31,0,0,1,2,1,2.73,2.73,0,0,1,2.21-1C277.83,359.76,278.88,360.6,278.88,362.47Z"
                    fill="#717272"
                />
                <path
                    id="Path_239"
                    data-name="Path 239"
                    d="M286.52,363.42h-4.64a1.63,1.63,0,0,0,1.75,1.23,2.11,2.11,0,0,0,1.54-.59l.95,1a3.22,3.22,0,0,1-2.53,1,3.18,3.18,0,0,1-3.5-3.15,3.12,3.12,0,0,1,3.27-3.16,3,3,0,0,1,3.19,3.18C286.55,363.07,286.53,363.27,286.52,363.42Zm-4.67-1h3a1.54,1.54,0,0,0-3,0Z"
                    fill="#717272"
                />
                <path
                    id="Path_240"
                    data-name="Path 240"
                    d="M287.15,365.41l.59-1.27a4.24,4.24,0,0,0,2.13.59c.82,0,1.13-.22,1.13-.56,0-1-3.71,0-3.71-2.43,0-1.16,1-2,2.84-2a5,5,0,0,1,2.36.53l-.59,1.27a3.55,3.55,0,0,0-1.77-.46c-.79,0-1.14.25-1.14.57,0,1.05,3.71,0,3.71,2.45,0,1.14-1.06,1.95-2.9,1.95a5.22,5.22,0,0,1-2.65-.64Z"
                    fill="#717272"
                />
                <path
                    id="Path_241"
                    data-name="Path 241"
                    d="M293.36,365a1.11,1.11,0,1,1,.52,1.048,1.11,1.11,0,0,1-.52-1.048Z"
                    fill="#717272"
                />
                <path
                    id="Path_242"
                    data-name="Path 242"
                    d="M297.91,368.37a85.274,85.274,0,0,1,0-13.81,85.281,85.281,0,0,1,0,13.81Z"
                    fill="#717272"
                />
                <rect
                    id="Rectangle_1"
                    data-name="Rectangle 1"
                    width="38.41"
                    height="31.83"
                    transform="translate(326.67 346.87)"
                    fill="#717272"
                    stroke="#fff"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
                <path
                    id="Path_243"
                    data-name="Path 243"
                    d="M344.52,367.08a7.28,7.28,0,1,1,7.29-7.28,7.28,7.28,0,0,1-7.29,7.28Zm0-13.49a6.22,6.22,0,1,0,6.22,6.21A6.22,6.22,0,0,0,344.52,353.59Z"
                    fill="#fff"
                />
                <path
                    id="Path_244"
                    data-name="Path 244"
                    d="M355.43,371.72a.52.52,0,0,1-.38-.16l-6.39-6.38a.56.56,0,0,1,0-.76.54.54,0,0,1,.76,0l6.39,6.39a.54.54,0,0,1-.38.91Z"
                    fill="#fff"
                />
                <path
                    id="Path_245"
                    data-name="Path 245"
                    d="M163.26,346.87h15.27l42.32-.07,144.25-.13h.28V379H321.67l.27-.28V402l-.48-.55L302,378.86l.2.09-139-.13h-.14v-.13c0-10.33.06-18.3.08-23.69v.11c0,5.38,0,13.32.07,23.62l-.13-.13,139-.13h.12l.08.09,19.44,22.54-.48.18V378.42h43.69l-.27.28V346.87l.27.27L221,347l-42.38-.07H164.26Z"
                    fill="#717373"
                    stroke="#fff"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
                <circle
                    id="Ellipse_7"
                    data-name="Ellipse 7"
                    cx="25.44"
                    cy="25.44"
                    r="25.44"
                    transform="translate(181.08 36.15)"
                    fill="#f4f5f6"
                    stroke="#717373"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
                <path
                    id="Path_246"
                    data-name="Path 246"
                    d="M232,61.59a1.91,1.91,0,0,1-.05-.41,6.512,6.512,0,0,0-.09-1.21,4.748,4.748,0,0,0-.06-.89c-.06-.33-.11-.67-.16-1.06a20.324,20.324,0,0,0-.54-2.61,24.54,24.54,0,0,0-2.83-6.73,25.29,25.29,0,0,0-6.44-7.15,24.94,24.94,0,0,0-10.62-4.7,25.26,25.26,0,0,0-13.23,1.11,26.338,26.338,0,0,0-3.28,1.44,25.349,25.349,0,0,0-3.09,2,28.29,28.29,0,0,0-2.86,2.43,28.851,28.851,0,0,0-2.46,2.91,24.35,24.35,0,0,0-3.6,6.94,27,27,0,0,0-1.3,7.94,27.05,27.05,0,0,0,1.3,7.94,24.3,24.3,0,0,0,3.6,6.93,27.911,27.911,0,0,0,2.46,2.92,28.29,28.29,0,0,0,2.86,2.43,25.352,25.352,0,0,0,3.09,2,26.34,26.34,0,0,0,3.28,1.44A25.138,25.138,0,0,0,228.23,74.5a24.54,24.54,0,0,0,2.83-6.73,20.324,20.324,0,0,0,.54-2.61c.05-.39.13-.74.16-1.06a7.96,7.96,0,0,1,.06-.89c0-.51.07-.91.09-1.21a1.91,1.91,0,0,1,.05-.41,2.122,2.122,0,0,1,0,.41c0,.3,0,.7,0,1.22v.89a9.275,9.275,0,0,1-.14,1.07,18.708,18.708,0,0,1-.49,2.65,24.41,24.41,0,0,1-2.77,6.83,25.64,25.64,0,0,1-17.24,12.15,26.26,26.26,0,0,1-16.85-2.55,27.211,27.211,0,0,1-3.16-2,29.477,29.477,0,0,1-2.92-2.48,30.141,30.141,0,0,1-2.52-3,25,25,0,0,1-3.68-7.09,27.489,27.489,0,0,1-1.33-8.11,27.56,27.56,0,0,1,1.33-8.12,25,25,0,0,1,3.68-7.08,30.142,30.142,0,0,1,2.52-3,29.479,29.479,0,0,1,2.92-2.48,28.6,28.6,0,0,1,3.16-2,25.94,25.94,0,0,1,3.35-1.46A25.54,25.54,0,0,1,228.55,48.5a24.16,24.16,0,0,1,2.78,6.83,18.71,18.71,0,0,1,.49,2.65c.05.39.11.74.14,1.07v2.11a2.12,2.12,0,0,1,.04.43Z"
                    fill="#f4f5f6"
                    stroke="#717373"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
                <path
                    id="Path_247"
                    data-name="Path 247"
                    d="M190.18,63.59a1.91,1.91,0,1,1,1.91,1.91A1.91,1.91,0,0,1,190.18,63.59Z"
                    fill="#717272"
                />
                <path
                    id="Path_248"
                    data-name="Path 248"
                    d="M206.75,50.75V65.36h-2.94V64.14a4.07,4.07,0,0,1-3.31,1.38,5.16,5.16,0,0,1-5.3-5.46,5.15,5.15,0,0,1,5.3-5.45,4,4,0,0,1,3.17,1.28V50.75Zm-3,9.31A2.71,2.71,0,1,0,201,63a2.68,2.68,0,0,0,2.73-2.94Z"
                    fill="#717272"
                />
                <path
                    id="Path_249"
                    data-name="Path 249"
                    d="M219.9,60.93h-8a2.83,2.83,0,0,0,3,2.13,3.6,3.6,0,0,0,2.66-1l1.63,1.78a5.55,5.55,0,0,1-4.37,1.71c-3.67,0-6.05-2.31-6.05-5.46a5.39,5.39,0,0,1,5.65-5.45A5.24,5.24,0,0,1,220,60.1C220,60.34,219.92,60.67,219.9,60.93Zm-8.06-1.79h5.22a2.65,2.65,0,0,0-5.22,0Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_8"
                    data-name="Ellipse 8"
                    cx="33.8"
                    cy="33.8"
                    r="33.8"
                    transform="translate(119 170.69)"
                    fill="#f4f5f6"
                    stroke="#717373"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
                <path
                    id="Path_250"
                    data-name="Path 250"
                    d="M186.59,204.49a4.479,4.479,0,0,0-.05-.55c-.05-.36-.06-.92-.11-1.61,0-.35-.05-.74-.07-1.18a13.986,13.986,0,0,0-.22-1.41,24.192,24.192,0,0,0-.71-3.48,32.12,32.12,0,0,0-3.75-8.95A33.74,33.74,0,0,0,159,171.51a32.732,32.732,0,0,0-4.24-.49c-.73,0-1.46-.09-2.19-.08l-2.22.12a6.021,6.021,0,0,0-1.12.07l-1.12.17c-.75.12-1.51.21-2.26.37a35,35,0,0,0-4.47,1.31,34.391,34.391,0,0,0-4.37,1.93c-.71.38-1.39.83-2.09,1.24a16.519,16.519,0,0,0-2,1.4,36.177,36.177,0,0,0-3.81,3.23,37.261,37.261,0,0,0-3.28,3.89A32.27,32.27,0,0,0,121,193.9a33.31,33.31,0,0,0,0,21.16,32.71,32.71,0,0,0,4.79,9.24,30.72,30.72,0,0,0,7.09,7.12,17.441,17.441,0,0,0,2,1.4c.7.41,1.38.86,2.09,1.24a34.389,34.389,0,0,0,4.37,1.93,35,35,0,0,0,4.47,1.31c.75.16,1.51.25,2.26.37l1.12.17a5.281,5.281,0,0,1,1.12.08l2.22.11c.74,0,1.47-.06,2.19-.08a32.531,32.531,0,0,0,4.24-.49,33.74,33.74,0,0,0,22.69-15.8,31.829,31.829,0,0,0,3.75-8.95,24.463,24.463,0,0,0,.71-3.48c.08-.51.17-1,.22-1.41s0-.83.07-1.18c0-.69.08-1.22.11-1.61s.05-.54.05-.54v.54c0,.36,0,.92-.06,1.61v1.19a11.626,11.626,0,0,1-.19,1.42,22.578,22.578,0,0,1-.66,3.51,32,32,0,0,1-3.69,9.06,33.91,33.91,0,0,1-22.87,16.09,32,32,0,0,1-4.3.51c-.74,0-1.48.1-2.22.09l-2.26-.11a6.182,6.182,0,0,1-1.13-.07l-1.14-.17c-.76-.12-1.53-.21-2.29-.37a36,36,0,0,1-4.54-1.32,35.551,35.551,0,0,1-4.45-1.95c-.72-.38-1.41-.84-2.12-1.26a17.874,17.874,0,0,1-2.06-1.41,30.93,30.93,0,0,1-7.21-7.23,32.76,32.76,0,0,1-4.88-9.39,33.71,33.71,0,0,1,0-21.5,33.09,33.09,0,0,1,4.88-9.38,30.93,30.93,0,0,1,7.21-7.23,16.687,16.687,0,0,1,2.06-1.41c.71-.42,1.4-.88,2.12-1.26a35.551,35.551,0,0,1,4.45-1.95,36,36,0,0,1,4.54-1.32c.76-.16,1.53-.25,2.29-.37l1.14-.17a6.128,6.128,0,0,0,1.13-.07l2.26-.11c.74,0,1.48.06,2.21.09a31.921,31.921,0,0,1,4.31.51A34,34,0,0,1,182,187.15a31.931,31.931,0,0,1,3.69,9.06,22.58,22.58,0,0,1,.66,3.51c.07.51.16,1,.19,1.42s0,.83,0,1.19a11.945,11.945,0,0,0,.06,1.61A1.1,1.1,0,0,1,186.59,204.49Z"
                    fill="#f4f5f6"
                    stroke="#717373"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
                <path
                    id="Path_251"
                    data-name="Path 251"
                    d="M126.77,208.85a2.4,2.4,0,1,1,1.151,2.207,2.4,2.4,0,0,1-1.151-2.207Z"
                    fill="#717272"
                />
                <path
                    id="Path_252"
                    data-name="Path 252"
                    d="M133,204.43c0-4,3.08-6.84,7.3-6.84s7.28,2.84,7.28,6.84-3.06,6.84-7.28,6.84S133,208.43,133,204.43Zm10.68,0a3.4,3.4,0,1,0-3.38,3.68,3.35,3.35,0,0,0,3.4-3.68Z"
                    fill="#717272"
                />
                <path
                    id="Path_253"
                    data-name="Path 253"
                    d="M158.4,197.59v3.56a8.591,8.591,0,0,0-.86-.05c-2.12,0-3.53,1.16-3.53,3.7v6.27h-3.85V197.79h3.68v1.75a5.37,5.37,0,0,1,4.56-1.95Z"
                    fill="#717272"
                />
                <path
                    id="Path_254"
                    data-name="Path 254"
                    d="M174.27,197.79v11.06c0,4.93-2.66,7.2-7.45,7.2a11,11,0,0,1-6.52-1.82l1.53-2.77a7.91,7.91,0,0,0,4.69,1.51c2.72,0,3.9-1.24,3.9-3.63v-.57a5.47,5.47,0,0,1-4.19,1.66,6.42,6.42,0,1,1,0-12.84,5.33,5.33,0,0,1,4.39,1.9v-1.7Zm-3.8,6.22a3.5,3.5,0,1,0-3.48,3.26,3.23,3.23,0,0,0,3.48-3.27Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_9"
                    data-name="Ellipse 9"
                    cx="33.8"
                    cy="33.8"
                    r="33.8"
                    transform="translate(336.94 186.52)"
                    fill="#f4f5f6"
                    stroke="#717373"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
                <path
                    id="Path_255"
                    data-name="Path 255"
                    d="M404.54,220.32a3.75,3.75,0,0,0-.06-.55c-.06-.36-.06-.92-.11-1.6a7.082,7.082,0,0,0-.07-1.18c-.07-.43-.14-.9-.22-1.41a24.569,24.569,0,0,0-.71-3.49,32.061,32.061,0,0,0-3.74-9,33.741,33.741,0,0,0-8.56-9.53,33.3,33.3,0,0,0-14.14-6.27,32.53,32.53,0,0,0-4.24-.49c-.72,0-1.45-.09-2.19-.08l-2.22.12a6.021,6.021,0,0,0-1.12.07l-1.12.17c-.75.13-1.51.21-2.26.37a35,35,0,0,0-4.47,1.31,35.869,35.869,0,0,0-4.37,1.93c-.71.38-1.39.83-2.09,1.25a16.1,16.1,0,0,0-2,1.39,30.209,30.209,0,0,0-7.09,7.12,32.2,32.2,0,0,0-4.79,9.24,35.559,35.559,0,0,0-1.73,10.57,35.941,35.941,0,0,0,1.72,10.58,32.481,32.481,0,0,0,4.8,9.24A37.26,37.26,0,0,0,347,244a36.184,36.184,0,0,0,3.81,3.23,16.521,16.521,0,0,0,2,1.4c.7.41,1.38.86,2.09,1.25a35.8,35.8,0,0,0,4.37,1.92,35,35,0,0,0,4.47,1.31c.76.16,1.52.25,2.26.37l1.12.17c.37.05.75.05,1.12.08l2.22.11c.74,0,1.47-.06,2.19-.08a30.9,30.9,0,0,0,4.24-.49A33.3,33.3,0,0,0,391.07,247a33.71,33.71,0,0,0,8.56-9.52,32.229,32.229,0,0,0,3.74-9,22.893,22.893,0,0,0,.71-3.48c.08-.51.17-1,.22-1.41s.05-.83.07-1.18c.05-.69.08-1.22.11-1.61a5.267,5.267,0,0,1,.06-.54v.54c0,.36,0,.92-.06,1.61v1.19a13.983,13.983,0,0,1-.19,1.42,24,24,0,0,1-.67,3.51,31.93,31.93,0,0,1-3.69,9.06A33.91,33.91,0,0,1,377,253.74a30.434,30.434,0,0,1-4.3.51c-.74,0-1.48.1-2.22.09l-2.25-.11a6.236,6.236,0,0,1-1.14-.07L366,254c-.75-.12-1.53-.21-2.29-.37a34.4,34.4,0,0,1-4.54-1.32,37,37,0,0,1-4.45-1.94c-.72-.39-1.41-.85-2.12-1.27a16.688,16.688,0,0,1-2.06-1.41,30.931,30.931,0,0,1-7.21-7.23,32.83,32.83,0,0,1-4.88-9.38,33.74,33.74,0,0,1,0-21.51,33.091,33.091,0,0,1,4.88-9.38,30.929,30.929,0,0,1,7.21-7.23,17.863,17.863,0,0,1,2.06-1.41c.71-.42,1.4-.87,2.12-1.26a35.547,35.547,0,0,1,4.45-1.95,36,36,0,0,1,4.54-1.32c.76-.16,1.53-.24,2.29-.37l1.14-.17c.38-.05.76,0,1.14-.07l2.25-.11c.74,0,1.48.06,2.22.09a32,32,0,0,1,4.3.51A34,34,0,0,1,399.89,203a32,32,0,0,1,3.69,9.06,24.479,24.479,0,0,1,.67,3.51c.06.52.15,1,.19,1.42a11.789,11.789,0,0,1,0,1.19,11.945,11.945,0,0,0,.06,1.61A2.147,2.147,0,0,1,404.54,220.32Z"
                    fill="#f4f5f6"
                    stroke="#717373"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
                <path
                    id="Path_256"
                    data-name="Path 256"
                    d="M351.16,224.22a2.08,2.08,0,1,1,.993,1.921A2.08,2.08,0,0,1,351.16,224.22Z"
                    fill="#717272"
                />
                <path
                    id="Path_257"
                    data-name="Path 257"
                    d="M369.36,219.55v6.6H366v-6.08c0-1.87-.86-2.72-2.34-2.72s-2.76,1-2.76,3.1v5.7h-3.34V214.63h3.19V216a5,5,0,0,1,3.81-1.52C367.3,214.46,369.36,216,369.36,219.55Z"
                    fill="#717272"
                />
                <path
                    id="Path_258"
                    data-name="Path 258"
                    d="M383.72,221.33H375a3.07,3.07,0,0,0,3.3,2.31,3.9,3.9,0,0,0,2.89-1.11l1.78,1.93a6.06,6.06,0,0,1-4.76,1.86c-4,0-6.57-2.51-6.57-5.93a5.86,5.86,0,0,1,6.14-5.93,5.7,5.7,0,0,1,6,6A6.943,6.943,0,0,1,383.72,221.33Zm-8.75-2h5.67a2.87,2.87,0,0,0-5.67,0Z"
                    fill="#717272"
                />
                <path
                    id="Path_259"
                    data-name="Path 259"
                    d="M393.45,225.59a4.8,4.8,0,0,1-2.72.73c-2.72,0-4.3-1.39-4.3-4.13v-4.73h-1.78v-2.57h1.78v-2.81h3.34v2.81h2.86v2.57h-2.86v4.68a1.34,1.34,0,0,0,1.43,1.52,2.3,2.3,0,0,0,1.35-.42Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_10"
                    data-name="Ellipse 10"
                    cx="33.28"
                    cy="33.28"
                    r="33.28"
                    transform="translate(302.372 110.37) rotate(-76.9)"
                    fill="#f4f5f6"
                    stroke="#717373"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
                <path
                    id="Path_260"
                    data-name="Path 260"
                    d="M375.63,85.51a4.268,4.268,0,0,0-.05-.54c-.05-.35-.06-.9-.11-1.58,0-.35-.05-.74-.07-1.16s-.14-.89-.22-1.39a24.459,24.459,0,0,0-.69-3.43,32.07,32.07,0,0,0-3.69-8.82,33.291,33.291,0,0,0-8.43-9.38A32.93,32.93,0,0,0,348.45,53a31.819,31.819,0,0,0-4.18-.48c-.71,0-1.43-.09-2.15-.08l-2.19.11a5.863,5.863,0,0,0-1.1.07l-1.1.17c-.74.13-1.49.21-2.23.36a36.079,36.079,0,0,0-4.4,1.3,34.672,34.672,0,0,0-4.3,1.89c-.7.38-1.37.82-2.06,1.23a16.74,16.74,0,0,0-2,1.37A38.8,38.8,0,0,0,319,62.17,37.354,37.354,0,0,0,315.77,66a31.809,31.809,0,0,0-4.72,9.09,32.75,32.75,0,0,0,0,20.83,32,32,0,0,0,4.72,9.1,37,37,0,0,0,3.23,3.82,36.362,36.362,0,0,0,3.75,3.19,16.743,16.743,0,0,0,2,1.37c.69.41,1.36.85,2.05,1.23a35.64,35.64,0,0,0,8.72,3.19c.73.15,1.48.24,2.22.36l1.1.17c.37.05.74.05,1.1.07l2.19.12c.72,0,1.44-.06,2.15-.09a28.43,28.43,0,0,0,4.18-.48,32.63,32.63,0,0,0,13.92-6.17,33,33,0,0,0,8.43-9.38,32,32,0,0,0,3.69-8.81,26.827,26.827,0,0,0,.7-3.43c.07-.51.16-1,.21-1.39s.05-.82.07-1.17c0-.67.08-1.2.11-1.57s.05-.54.05-.54v.54c0,.36,0,.9-.05,1.58V88.8a11.338,11.338,0,0,1-.19,1.4,24.753,24.753,0,0,1-.65,3.46,31.57,31.57,0,0,1-3.64,8.92,33.44,33.44,0,0,1-22.52,15.85,31.083,31.083,0,0,1-4.24.5c-.72,0-1.45.1-2.18.09l-2.22-.11a6.021,6.021,0,0,1-1.12-.07l-1.12-.17c-.75-.12-1.51-.21-2.26-.36a36.592,36.592,0,0,1-4.47-1.3,33.841,33.841,0,0,1-4.38-1.92c-.71-.38-1.39-.83-2.09-1.24a17.44,17.44,0,0,1-2-1.4,30.721,30.721,0,0,1-7.1-7.11,32.561,32.561,0,0,1-4.81-9.25,36.07,36.07,0,0,1-1.73-10.59,35.75,35.75,0,0,1,1.74-10.59,32.35,32.35,0,0,1,4.8-9.24,38.495,38.495,0,0,1,3.29-3.88,37.219,37.219,0,0,1,3.81-3.23,16.211,16.211,0,0,1,2-1.39c.7-.42,1.38-.86,2.09-1.25A35.2,35.2,0,0,1,330.93,54a33.348,33.348,0,0,1,4.47-1.3c.75-.16,1.51-.24,2.26-.37l1.12-.17a6.021,6.021,0,0,0,1.12-.07l2.22-.1c.73,0,1.46.06,2.18.09a31.08,31.08,0,0,1,4.24.5,33.48,33.48,0,0,1,22.52,15.84,31.57,31.57,0,0,1,3.64,8.92,24.757,24.757,0,0,1,.65,3.46c.07.51.15,1,.19,1.4a11.4,11.4,0,0,1,0,1.17,13.934,13.934,0,0,0,.05,1.59A3.327,3.327,0,0,1,375.63,85.51Z"
                    fill="#f4f5f6"
                    stroke="#717373"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
                <path
                    id="Path_261"
                    data-name="Path 261"
                    d="M312.72,90.41a2.15,2.15,0,1,1,1.028,1.983A2.15,2.15,0,0,1,312.72,90.41Z"
                    fill="#717272"
                />
                <path
                    id="Path_262"
                    data-name="Path 262"
                    d="M318.31,86.45c0-3.59,2.77-6.13,6.64-6.13,2.5,0,4.47,1.08,5.33,3l-2.67,1.44a3,3,0,0,0-2.68-1.64,3.3,3.3,0,0,0,0,6.59,2.94,2.94,0,0,0,2.68-1.63l2.67,1.46a5.52,5.52,0,0,1-5.33,3C321.08,92.58,318.31,90,318.31,86.45Z"
                    fill="#717272"
                />
                <path
                    id="Path_263"
                    data-name="Path 263"
                    d="M331.24,86.45c0-3.59,2.76-6.13,6.54-6.13s6.53,2.54,6.53,6.13-2.74,6.13-6.53,6.13S331.24,90,331.24,86.45Zm9.57,0a3,3,0,1,0-.769,2.311A3,3,0,0,0,340.81,86.45Z"
                    fill="#717272"
                />
                <path
                    id="Path_264"
                    data-name="Path 264"
                    d="M366.72,85.58V92.4h-3.45V86.12c0-1.93-.86-2.81-2.26-2.81s-2.63,1-2.63,3.12v6h-3.45V86.12c0-1.93-.82-2.81-2.26-2.81s-2.61,1-2.61,3.12v6h-3.45V80.5h3.3v1.37a4.8,4.8,0,0,1,3.74-1.55,4.42,4.42,0,0,1,3.91,2,5.34,5.34,0,0,1,4.29-2C364.69,80.32,366.72,82,366.72,85.58Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_11"
                    data-name="Ellipse 11"
                    cx="12.34"
                    cy="12.34"
                    r="12.34"
                    transform="translate(414.62 442.84)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_12"
                    data-name="Ellipse 12"
                    cx="7.31"
                    cy="7.31"
                    r="7.31"
                    transform="translate(443.63 409.75)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_13"
                    data-name="Ellipse 13"
                    cx="12.34"
                    cy="12.34"
                    r="12.34"
                    transform="translate(66.43 407.4)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_14"
                    data-name="Ellipse 14"
                    cx="7.31"
                    cy="7.31"
                    r="7.31"
                    transform="translate(107.44 444.82)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_265"
                    data-name="Path 265"
                    d="M28.07,104.48H18.31V94.74a1.21,1.21,0,0,0-1.21-1.21h0a1.23,1.23,0,0,0-1.24,1.21v9.74H6.13a1.23,1.23,0,0,0,0,2.46h9.73v9.75a1.23,1.23,0,0,0,1.24,1.21,1.21,1.21,0,0,0,1.21-1.21h0v-9.75h9.76a1.22,1.22,0,0,0,1.22-1.22,1.24,1.24,0,0,0-1.22-1.24Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_266"
                    data-name="Path 266"
                    d="M52.06,144.48H45.19v-6.87a.85.85,0,0,0-.85-.85h0a.88.88,0,0,0-.88.85v6.87H36.61a.87.87,0,1,0,0,1.73h6.85v6.87a.88.88,0,0,0,.88.86.86.86,0,0,0,.85-.86h0v-6.87h6.87a.87.87,0,1,0,0-1.73Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_267"
                    data-name="Path 267"
                    d="M505.92,125.88h-9.76v-9.74a1.21,1.21,0,0,0-1.21-1.21h0a1.25,1.25,0,0,0-1.24,1.21v9.74H484a1.24,1.24,0,0,0-1.22,1.24,1.22,1.22,0,0,0,1.22,1.21h9.73v9.76A1.25,1.25,0,0,0,495,139.3a1.21,1.21,0,0,0,1.21-1.21h0v-9.76h9.76a1.225,1.225,0,1,0-.05-2.45Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_268"
                    data-name="Path 268"
                    d="M481.16,181.23h-6.87v-6.87a.86.86,0,0,0-.86-.85h0a.87.87,0,0,0-.87.85v6.87H465.7a.87.87,0,0,0,0,1.73h6.86v6.87a.87.87,0,0,0,1.73,0h0V183h6.87a.87.87,0,1,0,0-1.73Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
            </g>
        </SVGIcon>
    );
}
